/*** Autogenerated. Use 'npm run generate-sources' to regenerate. ***/
            
import {Service} from '../../services/Service';
import {Configuration, ConfigurationParameters} from './runtime';
import {AdminPccApi, AgentsApi, BigRocksApi, ConfigurationsApi, FallbackApi, GroupsApi, HistoryApi, MonitorApi, PCCSApi, ProductsApi, RedAppsApi, RedAppsWhiteListApi, RoleGroupAssignmentsApi, RolesApi, UpdateSitesApi, VersionApi} from './apis';
import {Cached} from '../../../common/decorators/methods/Cached';
import {generateConverterToRx} from '../../../common/helpers/db/converters/generateConverterToRx';
import {generateArrayConverter} from '../../../common/helpers/db/converters/generateArrayConverter';

/* tslint:disable */
/* eslint-disable */
export * from './runtime';
export * from './apis';
export * from './models';


/**
* Service providing REST APIs for Aat
**/
export class AatApiService extends Service {
    /**
    *   Gets cached configuration object based on given configuration parameters.
    *   @param cfg Configuration parameters
    *   @returns Configuration object
    **/
    @Cached()
    private getConfiguration(cfg: ConfigurationParameters): Configuration {
        return new Configuration(cfg);
    }

                /**
                *   Promise of AdminPcc API client object
                *   @returns Promise of API object
                */
                get AdminPcc(): Promise<AdminPccApi> {
                    return this.services.http.getAatApiConfiguration$()
                        .then(cfg => this.getAdminPccApi(cfg))
                }
            
                /**
                *   Gets cached AdminPcc API client object
                *   @param cfg API configuration
                *   @returns API client object
                */
                @Cached()
                private getAdminPccApi(cfg: ConfigurationParameters): AdminPccApi {
                    return new AdminPccApi(this.getConfiguration(cfg));
                }
            
                /**
                *   Promise of Agents API client object
                *   @returns Promise of API object
                */
                get Agents(): Promise<AgentsApi> {
                    return this.services.http.getAatApiConfiguration$()
                        .then(cfg => this.getAgentsApi(cfg))
                }
            
                /**
                *   Gets cached Agents API client object
                *   @param cfg API configuration
                *   @returns API client object
                */
                @Cached()
                private getAgentsApi(cfg: ConfigurationParameters): AgentsApi {
                    return new AgentsApi(this.getConfiguration(cfg));
                }
            
                /**
                *   Promise of BigRocks API client object
                *   @returns Promise of API object
                */
                get BigRocks(): Promise<BigRocksApi> {
                    return this.services.http.getAatApiConfiguration$()
                        .then(cfg => this.getBigRocksApi(cfg))
                }
            
                /**
                *   Gets cached BigRocks API client object
                *   @param cfg API configuration
                *   @returns API client object
                */
                @Cached()
                private getBigRocksApi(cfg: ConfigurationParameters): BigRocksApi {
                    return new BigRocksApi(this.getConfiguration(cfg));
                }
            
                /**
                *   Promise of Configurations API client object
                *   @returns Promise of API object
                */
                get Configurations(): Promise<ConfigurationsApi> {
                    return this.services.http.getAatApiConfiguration$()
                        .then(cfg => this.getConfigurationsApi(cfg))
                }
            
                /**
                *   Gets cached Configurations API client object
                *   @param cfg API configuration
                *   @returns API client object
                */
                @Cached()
                private getConfigurationsApi(cfg: ConfigurationParameters): ConfigurationsApi {
                    return new ConfigurationsApi(this.getConfiguration(cfg));
                }
            
                /**
                *   Promise of Fallback API client object
                *   @returns Promise of API object
                */
                get Fallback(): Promise<FallbackApi> {
                    return this.services.http.getAatApiConfiguration$()
                        .then(cfg => this.getFallbackApi(cfg))
                }
            
                /**
                *   Gets cached Fallback API client object
                *   @param cfg API configuration
                *   @returns API client object
                */
                @Cached()
                private getFallbackApi(cfg: ConfigurationParameters): FallbackApi {
                    return new FallbackApi(this.getConfiguration(cfg));
                }
            
                /**
                *   Promise of Groups API client object
                *   @returns Promise of API object
                */
                get Groups(): Promise<GroupsApi> {
                    return this.services.http.getAatApiConfiguration$()
                        .then(cfg => this.getGroupsApi(cfg))
                }
            
                /**
                *   Gets cached Groups API client object
                *   @param cfg API configuration
                *   @returns API client object
                */
                @Cached()
                private getGroupsApi(cfg: ConfigurationParameters): GroupsApi {
                    return new GroupsApi(this.getConfiguration(cfg));
                }
            
                /**
                *   Promise of History API client object
                *   @returns Promise of API object
                */
                get History(): Promise<HistoryApi> {
                    return this.services.http.getAatApiConfiguration$()
                        .then(cfg => this.getHistoryApi(cfg))
                }
            
                /**
                *   Gets cached History API client object
                *   @param cfg API configuration
                *   @returns API client object
                */
                @Cached()
                private getHistoryApi(cfg: ConfigurationParameters): HistoryApi {
                    return new HistoryApi(this.getConfiguration(cfg));
                }
            
                /**
                *   Promise of Monitor API client object
                *   @returns Promise of API object
                */
                get Monitor(): Promise<MonitorApi> {
                    return this.services.http.getAatApiConfiguration$()
                        .then(cfg => this.getMonitorApi(cfg))
                }
            
                /**
                *   Gets cached Monitor API client object
                *   @param cfg API configuration
                *   @returns API client object
                */
                @Cached()
                private getMonitorApi(cfg: ConfigurationParameters): MonitorApi {
                    return new MonitorApi(this.getConfiguration(cfg));
                }
            
                /**
                *   Promise of PCCS API client object
                *   @returns Promise of API object
                */
                get PCCS(): Promise<PCCSApi> {
                    return this.services.http.getAatApiConfiguration$()
                        .then(cfg => this.getPCCSApi(cfg))
                }
            
                /**
                *   Gets cached PCCS API client object
                *   @param cfg API configuration
                *   @returns API client object
                */
                @Cached()
                private getPCCSApi(cfg: ConfigurationParameters): PCCSApi {
                    return new PCCSApi(this.getConfiguration(cfg));
                }
            
                /**
                *   Promise of Products API client object
                *   @returns Promise of API object
                */
                get Products(): Promise<ProductsApi> {
                    return this.services.http.getAatApiConfiguration$()
                        .then(cfg => this.getProductsApi(cfg))
                }
            
                /**
                *   Gets cached Products API client object
                *   @param cfg API configuration
                *   @returns API client object
                */
                @Cached()
                private getProductsApi(cfg: ConfigurationParameters): ProductsApi {
                    return new ProductsApi(this.getConfiguration(cfg));
                }
            
                /**
                *   Promise of RedApps API client object
                *   @returns Promise of API object
                */
                get RedApps(): Promise<RedAppsApi> {
                    return this.services.http.getAatApiConfiguration$()
                        .then(cfg => this.getRedAppsApi(cfg))
                }
            
                /**
                *   Gets cached RedApps API client object
                *   @param cfg API configuration
                *   @returns API client object
                */
                @Cached()
                private getRedAppsApi(cfg: ConfigurationParameters): RedAppsApi {
                    return new RedAppsApi(this.getConfiguration(cfg));
                }
            
                /**
                *   Promise of RedAppsWhiteList API client object
                *   @returns Promise of API object
                */
                get RedAppsWhiteList(): Promise<RedAppsWhiteListApi> {
                    return this.services.http.getAatApiConfiguration$()
                        .then(cfg => this.getRedAppsWhiteListApi(cfg))
                }
            
                /**
                *   Gets cached RedAppsWhiteList API client object
                *   @param cfg API configuration
                *   @returns API client object
                */
                @Cached()
                private getRedAppsWhiteListApi(cfg: ConfigurationParameters): RedAppsWhiteListApi {
                    return new RedAppsWhiteListApi(this.getConfiguration(cfg));
                }
            
                /**
                *   Promise of RoleGroupAssignments API client object
                *   @returns Promise of API object
                */
                get RoleGroupAssignments(): Promise<RoleGroupAssignmentsApi> {
                    return this.services.http.getAatApiConfiguration$()
                        .then(cfg => this.getRoleGroupAssignmentsApi(cfg))
                }
            
                /**
                *   Gets cached RoleGroupAssignments API client object
                *   @param cfg API configuration
                *   @returns API client object
                */
                @Cached()
                private getRoleGroupAssignmentsApi(cfg: ConfigurationParameters): RoleGroupAssignmentsApi {
                    return new RoleGroupAssignmentsApi(this.getConfiguration(cfg));
                }
            
                /**
                *   Promise of Roles API client object
                *   @returns Promise of API object
                */
                get Roles(): Promise<RolesApi> {
                    return this.services.http.getAatApiConfiguration$()
                        .then(cfg => this.getRolesApi(cfg))
                }
            
                /**
                *   Gets cached Roles API client object
                *   @param cfg API configuration
                *   @returns API client object
                */
                @Cached()
                private getRolesApi(cfg: ConfigurationParameters): RolesApi {
                    return new RolesApi(this.getConfiguration(cfg));
                }
            
                /**
                *   Promise of UpdateSites API client object
                *   @returns Promise of API object
                */
                get UpdateSites(): Promise<UpdateSitesApi> {
                    return this.services.http.getAatApiConfiguration$()
                        .then(cfg => this.getUpdateSitesApi(cfg))
                }
            
                /**
                *   Gets cached UpdateSites API client object
                *   @param cfg API configuration
                *   @returns API client object
                */
                @Cached()
                private getUpdateSitesApi(cfg: ConfigurationParameters): UpdateSitesApi {
                    return new UpdateSitesApi(this.getConfiguration(cfg));
                }
            
                /**
                *   Promise of Version API client object
                *   @returns Promise of API object
                */
                get Version(): Promise<VersionApi> {
                    return this.services.http.getAatApiConfiguration$()
                        .then(cfg => this.getVersionApi(cfg))
                }
            
                /**
                *   Gets cached Version API client object
                *   @param cfg API configuration
                *   @returns API client object
                */
                @Cached()
                private getVersionApi(cfg: ConfigurationParameters): VersionApi {
                    return new VersionApi(this.getConfiguration(cfg));
                }
            
}

import {AbstractSchemaBean, instanceOfAbstractSchemaBean, AbstractSchemaBeanFromJSON} from './models'; 
import {isDescribedByJsonSchema} from '../../../common/types/guards/isDescribedByJsonSchema';
import {isPartiallyDescribedByJsonSchema} from '../../../common/types/guards/isPartiallyDescribedByJsonSchema';
                
export const AbstractSchemaBeanSchema: any = {
    type: 'object',
    properties: {
        id: {
            type: 'integer',
            format: 'int64',
        },
        name: {
            type: 'string',
        },
        notes: {
            type: 'string',
        },
    },
};       

export const asAbstractSchemaBean = generateConverterToRx<AbstractSchemaBean>(AbstractSchemaBeanSchema, 'AbstractSchemaBeanSchema', AbstractSchemaBeanFromJSON, instanceOfAbstractSchemaBean, 'toCamelCase');
export const asAbstractSchemaBeanArray = generateArrayConverter<AbstractSchemaBean>(asAbstractSchemaBean);

export function isAbstractSchemaBean(o?: any): o is AbstractSchemaBean {
    return isDescribedByJsonSchema(o, AbstractSchemaBeanSchema, false, false);
}   
export function isPartialAbstractSchemaBean(o?: any): o is Partial<AbstractSchemaBean> {
    return isPartiallyDescribedByJsonSchema(o, AbstractSchemaBeanSchema);
}   
            
import {AdminPcc, instanceOfAdminPcc, AdminPccFromJSON} from './models'; 
                
export const AdminPccSchema: any = {
    type: 'object',
    properties: {
        onBehalfOf: {
            type: 'string',
        },
        onBehalfOfScCode: {
            type: 'string',
        },
    },
};       

export const asAdminPcc = generateConverterToRx<AdminPcc>(AdminPccSchema, 'AdminPccSchema', AdminPccFromJSON, instanceOfAdminPcc, 'toCamelCase');
export const asAdminPccArray = generateArrayConverter<AdminPcc>(asAdminPcc);

export function isAdminPcc(o?: any): o is AdminPcc {
    return isDescribedByJsonSchema(o, AdminPccSchema, false, false);
}   
export function isPartialAdminPcc(o?: any): o is Partial<AdminPcc> {
    return isPartiallyDescribedByJsonSchema(o, AdminPccSchema);
}   
            
import {AdminPccResponse, instanceOfAdminPccResponse, AdminPccResponseFromJSON} from './models'; 
                
export const AdminPccResponseSchema: any = {
    type: 'object',
    properties: {
        adminPcc: {
            type: 'object',
            properties: {
                onBehalfOf: {
                    type: 'string',
                },
                onBehalfOfScCode: {
                    type: 'string',
                },
            },
        },
        status: {
            type: 'string',
            enum: [
                'SUCCESS',
                'ERROR',
            ],
        },
        statusDescription: {
            type: 'string',
        },
    },
    discriminator: {
        propertyName: 'openApiType',
    },
    required: [
        'status',
    ],
};       

export const asAdminPccResponse = generateConverterToRx<AdminPccResponse>(AdminPccResponseSchema, 'AdminPccResponseSchema', AdminPccResponseFromJSON, instanceOfAdminPccResponse, 'toCamelCase');
export const asAdminPccResponseArray = generateArrayConverter<AdminPccResponse>(asAdminPccResponse);

export function isAdminPccResponse(o?: any): o is AdminPccResponse {
    return isDescribedByJsonSchema(o, AdminPccResponseSchema, false, false);
}   
export function isPartialAdminPccResponse(o?: any): o is Partial<AdminPccResponse> {
    return isPartiallyDescribedByJsonSchema(o, AdminPccResponseSchema);
}   
            
import {AssignAgentsRequest, instanceOfAssignAgentsRequest, AssignAgentsRequestFromJSON} from './models'; 
                
export const AssignAgentsRequestSchema: any = {
    type: 'object',
    properties: {
        cmGroupIds: {
            type: 'array',
            items: {
                type: 'integer',
                format: 'int64',
            },
        },
    },
};       

export const asAssignAgentsRequest = generateConverterToRx<AssignAgentsRequest>(AssignAgentsRequestSchema, 'AssignAgentsRequestSchema', AssignAgentsRequestFromJSON, instanceOfAssignAgentsRequest, 'toCamelCase');
export const asAssignAgentsRequestArray = generateArrayConverter<AssignAgentsRequest>(asAssignAgentsRequest);

export function isAssignAgentsRequest(o?: any): o is AssignAgentsRequest {
    return isDescribedByJsonSchema(o, AssignAgentsRequestSchema, false, false);
}   
export function isPartialAssignAgentsRequest(o?: any): o is Partial<AssignAgentsRequest> {
    return isPartiallyDescribedByJsonSchema(o, AssignAgentsRequestSchema);
}   
            
import {LockAgentsRequest, instanceOfLockAgentsRequest, LockAgentsRequestFromJSON} from './models'; 
                
export const LockAgentsRequestSchema: any = {
    type: 'object',
    properties: {
        cmGroupIds: {
            type: 'array',
            description: 'CM group ids of the agents whose lock state should be changed.',
            items: {
                type: 'integer',
                format: 'int64',
            },
        },
        lock: {
            type: 'boolean',
            default: true,
            description: 'True to apply an agency lock, false to release it.',
        },
    },
    required: [
        'cmGroupIds',
    ],
};       

export const asLockAgentsRequest = generateConverterToRx<LockAgentsRequest>(LockAgentsRequestSchema, 'LockAgentsRequestSchema', LockAgentsRequestFromJSON, instanceOfLockAgentsRequest, 'toCamelCase');
export const asLockAgentsRequestArray = generateArrayConverter<LockAgentsRequest>(asLockAgentsRequest);

export function isLockAgentsRequest(o?: any): o is LockAgentsRequest {
    return isDescribedByJsonSchema(o, LockAgentsRequestSchema, false, false);
}   
export function isPartialLockAgentsRequest(o?: any): o is Partial<LockAgentsRequest> {
    return isPartiallyDescribedByJsonSchema(o, LockAgentsRequestSchema);
}   
            
import {AuthorizationStatus, instanceOfAuthorizationStatus, AuthorizationStatusFromJSON} from './models'; 
                
export const AuthorizationStatusSchema: any = {
    type: 'object',
    required: [
        'authStatusCode',
        'status',
    ],
    properties: {
        user: {
            type: 'string',
        },
        pcc: {
            type: 'string',
        },
        onBehalfOf: {
            type: 'string',
        },
        onBehalfOfScCode: {
            type: 'string',
        },
        authDescription: {
            type: 'string',
        },
        adminType: {
            type: 'string',
        },
        authStatusCode: {
            type: 'string',
            enum: [
                'AUTHORIZED',
                'AUTHORIZED_ON_BEHALF_OF',
                'UNAUTHORIZED',
                'FORBIDDEN',
            ],
        },
        status: {
            type: 'string',
            enum: [
                'SUCCESS',
                'ERROR',
            ],
        },
        statusDescription: {
            type: 'string',
        },
    },
    discriminator: {
        propertyName: 'openApiType',
    },
};       

export const asAuthorizationStatus = generateConverterToRx<AuthorizationStatus>(AuthorizationStatusSchema, 'AuthorizationStatusSchema', AuthorizationStatusFromJSON, instanceOfAuthorizationStatus, 'toCamelCase');
export const asAuthorizationStatusArray = generateArrayConverter<AuthorizationStatus>(asAuthorizationStatus);

export function isAuthorizationStatus(o?: any): o is AuthorizationStatus {
    return isDescribedByJsonSchema(o, AuthorizationStatusSchema, false, false);
}   
export function isPartialAuthorizationStatus(o?: any): o is Partial<AuthorizationStatus> {
    return isPartiallyDescribedByJsonSchema(o, AuthorizationStatusSchema);
}   
            
import {BigRock, instanceOfBigRock, BigRockFromJSON} from './models'; 
                
export const BigRockSchema: any = {
    type: 'object',
    properties: {
        name: {
            type: 'string',
        },
        roleOn: {
            type: 'object',
            properties: {
                id: {
                    type: 'integer',
                    format: 'int64',
                },
                name: {
                    type: 'string',
                },
                notes: {
                    type: 'string',
                },
            },
        },
        roleOff: {
            type: 'object',
            properties: {
                id: {
                    type: 'integer',
                    format: 'int64',
                },
                name: {
                    type: 'string',
                },
                notes: {
                    type: 'string',
                },
            },
        },
        groupRockRole: {
            type: 'object',
            properties: {
                id: {
                    type: 'integer',
                    format: 'int64',
                },
                name: {
                    type: 'string',
                },
                notes: {
                    type: 'string',
                },
            },
        },
        properties: {
            type: 'array',
            items: {
                type: 'object',
                properties: {
                    id: {
                        type: 'integer',
                        format: 'int64',
                    },
                    name: {
                        type: 'string',
                    },
                    description: {
                        type: 'string',
                    },
                    overrideValue: {
                        type: 'string',
                    },
                    possibleValues: {
                        type: 'object',
                    },
                    additionalProperties: {
                        type: 'string',
                    },
                    allowUserOverride: {
                        type: 'boolean',
                    },
                },
                required: [
                    'id',
                ],
            },
        },
        propertiesSet: {
            type: 'array',
            items: {
                type: 'object',
                properties: {
                    id: {
                        type: 'integer',
                        format: 'int64',
                    },
                    name: {
                        type: 'string',
                    },
                    description: {
                        type: 'string',
                    },
                    overrideValue: {
                        type: 'string',
                    },
                    possibleValues: {
                        type: 'object',
                    },
                    additionalProperties: {
                        type: 'string',
                    },
                    allowUserOverride: {
                        type: 'boolean',
                    },
                },
                required: [
                    'id',
                ],
            },
        },
        destiny: {
            type: 'array',
            items: {
                type: 'string',
            },
        },
        enabledGroupIds: {
            type: 'array',
            items: {
                type: 'integer',
                format: 'int64',
            },
        },
        disabledGroupIds: {
            type: 'array',
            items: {
                type: 'integer',
                format: 'int64',
            },
        },
        subRocks: {
            type: 'array',
            items: {},
        },
        isSubRock: {
            type: 'boolean',
            default: false,
        },
    },
    required: [
        'name',
    ],
};       

export const asBigRock = generateConverterToRx<BigRock>(BigRockSchema, 'BigRockSchema', BigRockFromJSON, instanceOfBigRock, 'toCamelCase');
export const asBigRockArray = generateArrayConverter<BigRock>(asBigRock);

export function isBigRock(o?: any): o is BigRock {
    return isDescribedByJsonSchema(o, BigRockSchema, false, false);
}   
export function isPartialBigRock(o?: any): o is Partial<BigRock> {
    return isPartiallyDescribedByJsonSchema(o, BigRockSchema);
}   
            
import {BigRocksResponse, instanceOfBigRocksResponse, BigRocksResponseFromJSON} from './models'; 
                
export const BigRocksResponseSchema: any = {
    type: 'object',
    required: [
        'big_rocks',
        'status',
    ],
    properties: {
        bigRocks: {
            type: 'array',
            items: {
                type: 'object',
                properties: {
                    name: {
                        type: 'string',
                    },
                    role_on: {
                        type: 'object',
                        properties: {
                            id: {
                                type: 'integer',
                                format: 'int64',
                            },
                            name: {
                                type: 'string',
                            },
                            notes: {
                                type: 'string',
                            },
                        },
                    },
                    role_off: {
                        type: 'object',
                        properties: {
                            id: {
                                type: 'integer',
                                format: 'int64',
                            },
                            name: {
                                type: 'string',
                            },
                            notes: {
                                type: 'string',
                            },
                        },
                    },
                    group_rock_role: {
                        type: 'object',
                        properties: {
                            id: {
                                type: 'integer',
                                format: 'int64',
                            },
                            name: {
                                type: 'string',
                            },
                            notes: {
                                type: 'string',
                            },
                        },
                    },
                    properties: {
                        type: 'array',
                        items: {
                            type: 'object',
                            properties: {
                                id: {
                                    type: 'integer',
                                    format: 'int64',
                                },
                                name: {
                                    type: 'string',
                                },
                                description: {
                                    type: 'string',
                                },
                                overrideValue: {
                                    type: 'string',
                                },
                                possibleValues: {
                                    type: 'object',
                                },
                                additionalProperties: {
                                    type: 'string',
                                },
                                allowUserOverride: {
                                    type: 'boolean',
                                },
                            },
                            required: [
                                'id',
                            ],
                        },
                    },
                    properties_set: {
                        type: 'array',
                        items: {
                            type: 'object',
                            properties: {
                                id: {
                                    type: 'integer',
                                    format: 'int64',
                                },
                                name: {
                                    type: 'string',
                                },
                                description: {
                                    type: 'string',
                                },
                                overrideValue: {
                                    type: 'string',
                                },
                                possibleValues: {
                                    type: 'object',
                                },
                                additionalProperties: {
                                    type: 'string',
                                },
                                allowUserOverride: {
                                    type: 'boolean',
                                },
                            },
                            required: [
                                'id',
                            ],
                        },
                    },
                    destiny: {
                        type: 'array',
                        items: {
                            type: 'string',
                        },
                    },
                    enabled_group_ids: {
                        type: 'array',
                        items: {
                            type: 'integer',
                            format: 'int64',
                        },
                    },
                    disabled_group_ids: {
                        type: 'array',
                        items: {
                            type: 'integer',
                            format: 'int64',
                        },
                    },
                    sub_rocks: {
                        type: 'array',
                        items: {},
                    },
                    is_sub_rock: {
                        type: 'boolean',
                        default: false,
                    },
                },
                required: [
                    'name',
                ],
            },
        },
        status: {
            type: 'string',
            enum: [
                'SUCCESS',
                'ERROR',
            ],
        },
        statusDescription: {
            type: 'string',
        },
    },
    discriminator: {
        propertyName: 'openApiType',
    },
};       

export const asBigRocksResponse = generateConverterToRx<BigRocksResponse>(BigRocksResponseSchema, 'BigRocksResponseSchema', BigRocksResponseFromJSON, instanceOfBigRocksResponse, 'toCamelCase');
export const asBigRocksResponseArray = generateArrayConverter<BigRocksResponse>(asBigRocksResponse);

export function isBigRocksResponse(o?: any): o is BigRocksResponse {
    return isDescribedByJsonSchema(o, BigRocksResponseSchema, false, false);
}   
export function isPartialBigRocksResponse(o?: any): o is Partial<BigRocksResponse> {
    return isPartiallyDescribedByJsonSchema(o, BigRocksResponseSchema);
}   
            
import {ConfigItem, instanceOfConfigItem, ConfigItemFromJSON} from './models'; 
                
export const ConfigItemSchema: any = {
    type: 'object',
    properties: {
        id: {
            type: 'integer',
            format: 'int64',
        },
        notes: {
            type: 'string',
        },
        value: {
            type: 'string',
        },
        levelLocked: {
            type: 'boolean',
        },
        allowUserOverride: {
            type: 'boolean',
        },
        relatedProductName: {
            type: 'string',
            maxLength: 240,
        },
        roleId: {
            type: 'integer',
            format: 'int64',
        },
        productId: {
            type: 'integer',
            format: 'int64',
        },
        propertyId: {
            type: 'integer',
            format: 'int64',
        },
    },
};       

export const asConfigItem = generateConverterToRx<ConfigItem>(ConfigItemSchema, 'ConfigItemSchema', ConfigItemFromJSON, instanceOfConfigItem, 'toCamelCase');
export const asConfigItemArray = generateArrayConverter<ConfigItem>(asConfigItem);

export function isConfigItem(o?: any): o is ConfigItem {
    return isDescribedByJsonSchema(o, ConfigItemSchema, false, false);
}   
export function isPartialConfigItem(o?: any): o is Partial<ConfigItem> {
    return isPartiallyDescribedByJsonSchema(o, ConfigItemSchema);
}   
            
import {ModelConfiguration, instanceOfModelConfiguration, ModelConfigurationFromJSON} from './models'; 
                
export const ModelConfigurationSchema: any = {
    type: 'object',
    required: [
        'id',
        'redappName',
        'configurationName',
        'value',
        'description',
    ],
    properties: {
        id: {
            type: 'integer',
            format: 'int64',
        },
        redappName: {
            type: 'string',
        },
        configurationName: {
            type: 'string',
        },
        value: {
            type: 'string',
        },
        description: {
            type: 'string',
        },
        forceSave: {
            type: 'boolean',
        },
    },
    discriminator: {
        propertyName: 'openApiType',
    },
};       

export const asModelConfiguration = generateConverterToRx<ModelConfiguration>(ModelConfigurationSchema, 'ModelConfigurationSchema', ModelConfigurationFromJSON, instanceOfModelConfiguration, 'toCamelCase');
export const asModelConfigurationArray = generateArrayConverter<ModelConfiguration>(asModelConfiguration);

export function isModelConfiguration(o?: any): o is ModelConfiguration {
    return isDescribedByJsonSchema(o, ModelConfigurationSchema, false, false);
}   
export function isPartialModelConfiguration(o?: any): o is Partial<ModelConfiguration> {
    return isPartiallyDescribedByJsonSchema(o, ModelConfigurationSchema);
}   
            
import {ConfigurationResponse, instanceOfConfigurationResponse, ConfigurationResponseFromJSON} from './models'; 
                
export const ConfigurationResponseSchema: any = {
    type: 'object',
    required: [
        'configurations',
        'status',
    ],
    properties: {
        configurations: {
            type: 'array',
            items: {
                type: 'object',
                required: [
                    'id',
                    'redappName',
                    'configurationName',
                    'value',
                    'description',
                ],
                properties: {
                    id: {
                        type: 'integer',
                        format: 'int64',
                    },
                    redappName: {
                        type: 'string',
                    },
                    configurationName: {
                        type: 'string',
                    },
                    value: {
                        type: 'string',
                    },
                    description: {
                        type: 'string',
                    },
                    forceSave: {
                        type: 'boolean',
                    },
                },
                discriminator: {
                    propertyName: 'openApiType',
                },
            },
        },
        verificationStatus: {
            type: 'object',
            discriminator: {
                propertyName: 'openApiType',
            },
            required: [
                'status',
            ],
            properties: {
                status: {
                    type: 'string',
                    enum: [
                        'SUCCESS',
                        'ERROR',
                    ],
                },
                statusDescription: {
                    type: 'string',
                },
            },
        },
        status: {
            type: 'string',
            enum: [
                'SUCCESS',
                'ERROR',
            ],
        },
        statusDescription: {
            type: 'string',
        },
    },
    discriminator: {
        propertyName: 'openApiType',
    },
};       

export const asConfigurationResponse = generateConverterToRx<ConfigurationResponse>(ConfigurationResponseSchema, 'ConfigurationResponseSchema', ConfigurationResponseFromJSON, instanceOfConfigurationResponse, 'toCamelCase');
export const asConfigurationResponseArray = generateArrayConverter<ConfigurationResponse>(asConfigurationResponse);

export function isConfigurationResponse(o?: any): o is ConfigurationResponse {
    return isDescribedByJsonSchema(o, ConfigurationResponseSchema, false, false);
}   
export function isPartialConfigurationResponse(o?: any): o is Partial<ConfigurationResponse> {
    return isPartiallyDescribedByJsonSchema(o, ConfigurationResponseSchema);
}   
            
import {ConfigurationSchemaResponse, instanceOfConfigurationSchemaResponse, ConfigurationSchemaResponseFromJSON} from './models'; 
                
export const ConfigurationSchemaResponseSchema: any = {
    type: 'object',
    required: [
        'schema',
        'status',
    ],
    properties: {
        schema: {
            type: 'string',
        },
        verificationStatus: {
            type: 'object',
            discriminator: {
                propertyName: 'openApiType',
            },
            required: [
                'status',
            ],
            properties: {
                status: {
                    type: 'string',
                    enum: [
                        'SUCCESS',
                        'ERROR',
                    ],
                },
                statusDescription: {
                    type: 'string',
                },
            },
        },
        status: {
            type: 'string',
            enum: [
                'SUCCESS',
                'ERROR',
            ],
        },
        statusDescription: {
            type: 'string',
        },
    },
    discriminator: {
        propertyName: 'openApiType',
    },
};       

export const asConfigurationSchemaResponse = generateConverterToRx<ConfigurationSchemaResponse>(ConfigurationSchemaResponseSchema, 'ConfigurationSchemaResponseSchema', ConfigurationSchemaResponseFromJSON, instanceOfConfigurationSchemaResponse, 'toCamelCase');
export const asConfigurationSchemaResponseArray = generateArrayConverter<ConfigurationSchemaResponse>(asConfigurationSchemaResponse);

export function isConfigurationSchemaResponse(o?: any): o is ConfigurationSchemaResponse {
    return isDescribedByJsonSchema(o, ConfigurationSchemaResponseSchema, false, false);
}   
export function isPartialConfigurationSchemaResponse(o?: any): o is Partial<ConfigurationSchemaResponse> {
    return isPartiallyDescribedByJsonSchema(o, ConfigurationSchemaResponseSchema);
}   
            
import {CreateConfigurationRequest, instanceOfCreateConfigurationRequest, CreateConfigurationRequestFromJSON} from './models'; 
                
export const CreateConfigurationRequestSchema: any = {
    type: 'object',
    required: [
        'redappName',
        'configurationName',
        'value',
        'description',
    ],
    properties: {
        redappName: {
            type: 'string',
        },
        configurationName: {
            type: 'string',
        },
        value: {
            type: 'string',
        },
        description: {
            type: 'string',
        },
        forceSave: {
            type: 'boolean',
        },
    },
    discriminator: {
        propertyName: 'openApiType',
    },
};       

export const asCreateConfigurationRequest = generateConverterToRx<CreateConfigurationRequest>(CreateConfigurationRequestSchema, 'CreateConfigurationRequestSchema', CreateConfigurationRequestFromJSON, instanceOfCreateConfigurationRequest, 'toCamelCase');
export const asCreateConfigurationRequestArray = generateArrayConverter<CreateConfigurationRequest>(asCreateConfigurationRequest);

export function isCreateConfigurationRequest(o?: any): o is CreateConfigurationRequest {
    return isDescribedByJsonSchema(o, CreateConfigurationRequestSchema, false, false);
}   
export function isPartialCreateConfigurationRequest(o?: any): o is Partial<CreateConfigurationRequest> {
    return isPartiallyDescribedByJsonSchema(o, CreateConfigurationRequestSchema);
}   
            
import {UpdateConfigurationRequest, instanceOfUpdateConfigurationRequest, UpdateConfigurationRequestFromJSON} from './models'; 
                
export const UpdateConfigurationRequestSchema: any = {
    type: 'object',
    discriminator: {
        propertyName: 'openApiType',
    },
    required: [
        'configurationName',
        'value',
        'description',
    ],
    properties: {
        configurationName: {
            type: 'string',
        },
        value: {
            type: 'string',
        },
        description: {
            type: 'string',
        },
        forceSave: {
            type: 'boolean',
        },
    },
};       

export const asUpdateConfigurationRequest = generateConverterToRx<UpdateConfigurationRequest>(UpdateConfigurationRequestSchema, 'UpdateConfigurationRequestSchema', UpdateConfigurationRequestFromJSON, instanceOfUpdateConfigurationRequest, 'toCamelCase');
export const asUpdateConfigurationRequestArray = generateArrayConverter<UpdateConfigurationRequest>(asUpdateConfigurationRequest);

export function isUpdateConfigurationRequest(o?: any): o is UpdateConfigurationRequest {
    return isDescribedByJsonSchema(o, UpdateConfigurationRequestSchema, false, false);
}   
export function isPartialUpdateConfigurationRequest(o?: any): o is Partial<UpdateConfigurationRequest> {
    return isPartiallyDescribedByJsonSchema(o, UpdateConfigurationRequestSchema);
}   
            
import {RoleGroups, instanceOfRoleGroups, RoleGroupsFromJSON} from './models'; 
                
export const RoleGroupsSchema: any = {
    type: 'object',
    properties: {
        groups: {
            type: 'array',
            items: {
                type: 'object',
                properties: {
                    id: {
                        type: 'integer',
                        format: 'int64',
                    },
                    name: {
                        type: 'string',
                    },
                },
                required: [
                    'id',
                ],
            },
        },
    },
};       

export const asRoleGroups = generateConverterToRx<RoleGroups>(RoleGroupsSchema, 'RoleGroupsSchema', RoleGroupsFromJSON, instanceOfRoleGroups, 'toCamelCase');
export const asRoleGroupsArray = generateArrayConverter<RoleGroups>(asRoleGroups);

export function isRoleGroups(o?: any): o is RoleGroups {
    return isDescribedByJsonSchema(o, RoleGroupsSchema, false, false);
}   
export function isPartialRoleGroups(o?: any): o is Partial<RoleGroups> {
    return isPartiallyDescribedByJsonSchema(o, RoleGroupsSchema);
}   
            
import {RoleGroupsResponse, instanceOfRoleGroupsResponse, RoleGroupsResponseFromJSON} from './models'; 
                
export const RoleGroupsResponseSchema: any = {
    type: 'object',
    properties: {
        roleGroups: {
            type: 'object',
            properties: {
                groups: {
                    type: 'array',
                    items: {
                        type: 'object',
                        properties: {
                            id: {
                                type: 'integer',
                                format: 'int64',
                            },
                            name: {
                                type: 'string',
                            },
                        },
                        required: [
                            'id',
                        ],
                    },
                },
            },
        },
        status: {
            type: 'string',
            enum: [
                'SUCCESS',
                'ERROR',
            ],
        },
        statusDescription: {
            type: 'string',
        },
    },
    discriminator: {
        propertyName: 'openApiType',
    },
    required: [
        'status',
    ],
};       

export const asRoleGroupsResponse = generateConverterToRx<RoleGroupsResponse>(RoleGroupsResponseSchema, 'RoleGroupsResponseSchema', RoleGroupsResponseFromJSON, instanceOfRoleGroupsResponse, 'toCamelCase');
export const asRoleGroupsResponseArray = generateArrayConverter<RoleGroupsResponse>(asRoleGroupsResponse);

export function isRoleGroupsResponse(o?: any): o is RoleGroupsResponse {
    return isDescribedByJsonSchema(o, RoleGroupsResponseSchema, false, false);
}   
export function isPartialRoleGroupsResponse(o?: any): o is Partial<RoleGroupsResponse> {
    return isPartiallyDescribedByJsonSchema(o, RoleGroupsResponseSchema);
}   
            
import {Agency, instanceOfAgency, AgencyFromJSON} from './models'; 
                
export const AgencySchema: any = {
    type: 'object',
    properties: {
        id: {
            type: 'integer',
            format: 'int64',
        },
        name: {
            type: 'string',
        },
        location: {
            type: 'object',
            properties: {
                country: {
                    type: 'string',
                },
                countryCode: {
                    type: 'string',
                },
                state: {
                    type: 'string',
                },
                city: {
                    type: 'string',
                },
                street: {
                    type: 'string',
                },
            },
            required: [
                'country',
                'countryCode',
            ],
        },
        groups: {
            type: 'array',
            items: {
                type: 'object',
                required: [
                    'id',
                    'name',
                ],
                properties: {
                    id: {
                        type: 'integer',
                        format: 'int64',
                    },
                    name: {
                        type: 'string',
                    },
                    description: {
                        type: 'string',
                    },
                    totalAgents: {
                        type: 'integer',
                    },
                    editorName: {
                        type: 'string',
                    },
                    applicationType: {
                        type: 'string',
                    },
                    platformAccess: {
                        type: 'string',
                        description: 'Explicit Agency Workspace platform access. DESKTOP_ONLY disables web access and clears the desktop block. WEB_ONLY enables web access and the Desktop_Disabled role. DESKTOP_WEB enables web access and clears the desktop block. When applicationType is supplied, application settings are replaced on create and update, and omitting platformAccess removes platform overrides. An empty applicationType clears application settings. A null or omitted applicationType leaves application settings unchanged.\n',
                        enum: [
                            'DESKTOP_ONLY',
                            'WEB_ONLY',
                            'DESKTOP_WEB',
                        ],
                    },
                    welcomeScreen: {
                        type: 'string',
                    },
                    holdReservation: {
                        type: 'string',
                    },
                },
            },
        },
    },
    required: [
        'id',
        'name',
    ],
};       

export const asAgency = generateConverterToRx<Agency>(AgencySchema, 'AgencySchema', AgencyFromJSON, instanceOfAgency, 'toCamelCase');
export const asAgencyArray = generateArrayConverter<Agency>(asAgency);

export function isAgency(o?: any): o is Agency {
    return isDescribedByJsonSchema(o, AgencySchema, false, false);
}   
export function isPartialAgency(o?: any): o is Partial<Agency> {
    return isPartiallyDescribedByJsonSchema(o, AgencySchema);
}   
            
import {Agent, instanceOfAgent, AgentFromJSON} from './models'; 
                
export const AgentSchema: any = {
    type: 'object',
    properties: {
        id: {
            type: 'integer',
            format: 'int64',
        },
        sabreId: {
            type: 'string',
        },
        name: {
            type: 'string',
        },
        pcc: {
            type: 'object',
            properties: {
                id: {
                    type: 'integer',
                    format: 'int64',
                },
                pcc: {
                    type: 'string',
                },
                sccode: {
                    type: 'string',
                },
                agencyName: {
                    type: 'string',
                },
                location: {
                    type: 'object',
                    properties: {
                        country: {
                            type: 'string',
                        },
                        countryCode: {
                            type: 'string',
                        },
                        state: {
                            type: 'string',
                        },
                        city: {
                            type: 'string',
                        },
                        street: {
                            type: 'string',
                        },
                    },
                    required: [
                        'country',
                        'countryCode',
                    ],
                },
                agency: {
                    type: 'object',
                    properties: {
                        id: {
                            type: 'integer',
                            format: 'int64',
                        },
                        name: {
                            type: 'string',
                        },
                        location: {
                            type: 'object',
                            properties: {
                                country: {
                                    type: 'string',
                                },
                                countryCode: {
                                    type: 'string',
                                },
                                state: {
                                    type: 'string',
                                },
                                city: {
                                    type: 'string',
                                },
                                street: {
                                    type: 'string',
                                },
                            },
                            required: [
                                'country',
                                'countryCode',
                            ],
                        },
                        groups: {
                            type: 'array',
                            items: {
                                type: 'object',
                                required: [
                                    'id',
                                    'name',
                                ],
                                properties: {
                                    id: {
                                        type: 'integer',
                                        format: 'int64',
                                    },
                                    name: {
                                        type: 'string',
                                    },
                                    description: {
                                        type: 'string',
                                    },
                                    totalAgents: {
                                        type: 'integer',
                                    },
                                    editorName: {
                                        type: 'string',
                                    },
                                    applicationType: {
                                        type: 'string',
                                    },
                                    platformAccess: {
                                        type: 'string',
                                        description: 'Explicit Agency Workspace platform access. DESKTOP_ONLY disables web access and clears the desktop block. WEB_ONLY enables web access and the Desktop_Disabled role. DESKTOP_WEB enables web access and clears the desktop block. When applicationType is supplied, application settings are replaced on create and update, and omitting platformAccess removes platform overrides. An empty applicationType clears application settings. A null or omitted applicationType leaves application settings unchanged.\n',
                                        enum: [
                                            'DESKTOP_ONLY',
                                            'WEB_ONLY',
                                            'DESKTOP_WEB',
                                        ],
                                    },
                                    welcomeScreen: {
                                        type: 'string',
                                    },
                                    holdReservation: {
                                        type: 'string',
                                    },
                                },
                            },
                        },
                    },
                    required: [
                        'id',
                        'name',
                    ],
                },
                groups: {
                    type: 'array',
                    items: {
                        type: 'object',
                        required: [
                            'id',
                            'name',
                        ],
                        properties: {
                            id: {
                                type: 'integer',
                                format: 'int64',
                            },
                            name: {
                                type: 'string',
                            },
                            description: {
                                type: 'string',
                            },
                            totalAgents: {
                                type: 'integer',
                            },
                            editorName: {
                                type: 'string',
                            },
                            applicationType: {
                                type: 'string',
                            },
                            platformAccess: {
                                type: 'string',
                                description: 'Explicit Agency Workspace platform access. DESKTOP_ONLY disables web access and clears the desktop block. WEB_ONLY enables web access and the Desktop_Disabled role. DESKTOP_WEB enables web access and clears the desktop block. When applicationType is supplied, application settings are replaced on create and update, and omitting platformAccess removes platform overrides. An empty applicationType clears application settings. A null or omitted applicationType leaves application settings unchanged.\n',
                                enum: [
                                    'DESKTOP_ONLY',
                                    'WEB_ONLY',
                                    'DESKTOP_WEB',
                                ],
                            },
                            welcomeScreen: {
                                type: 'string',
                            },
                            holdReservation: {
                                type: 'string',
                            },
                        },
                    },
                },
            },
            required: [
                'id',
                'pcc',
            ],
        },
        groups: {
            type: 'array',
            items: {
                type: 'object',
                required: [
                    'id',
                    'name',
                ],
                properties: {
                    id: {
                        type: 'integer',
                        format: 'int64',
                    },
                    name: {
                        type: 'string',
                    },
                    description: {
                        type: 'string',
                    },
                    totalAgents: {
                        type: 'integer',
                    },
                    editorName: {
                        type: 'string',
                    },
                    applicationType: {
                        type: 'string',
                    },
                    platformAccess: {
                        type: 'string',
                        description: 'Explicit Agency Workspace platform access. DESKTOP_ONLY disables web access and clears the desktop block. WEB_ONLY enables web access and the Desktop_Disabled role. DESKTOP_WEB enables web access and clears the desktop block. When applicationType is supplied, application settings are replaced on create and update, and omitting platformAccess removes platform overrides. An empty applicationType clears application settings. A null or omitted applicationType leaves application settings unchanged.\n',
                        enum: [
                            'DESKTOP_ONLY',
                            'WEB_ONLY',
                            'DESKTOP_WEB',
                        ],
                    },
                    welcomeScreen: {
                        type: 'string',
                    },
                    holdReservation: {
                        type: 'string',
                    },
                },
            },
        },
        locked: {
            type: 'boolean',
            description: 'True when the agent is currently locked in CM, either by an agency lock, a Sabre lock or an active blueprint recall.',
        },
        lockType: {
            type: 'string',
            description: 'Type of the lock currently applied to the agent.',
            enum: [
                'AGENCY',
                'SABRE',
                'RECALL',
            ],
        },
        lockExpirationDate: {
            type: 'string',
            format: 'date-time',
            description: 'Date the currently active lock expires. Not set for recall locks.',
        },
    },
    required: [
        'id',
        'sabreId',
        'name',
    ],
};       

export const asAgent = generateConverterToRx<Agent>(AgentSchema, 'AgentSchema', AgentFromJSON, instanceOfAgent, 'toCamelCase');
export const asAgentArray = generateArrayConverter<Agent>(asAgent);

export function isAgent(o?: any): o is Agent {
    return isDescribedByJsonSchema(o, AgentSchema, false, false);
}   
export function isPartialAgent(o?: any): o is Partial<Agent> {
    return isPartiallyDescribedByJsonSchema(o, AgentSchema);
}   
            
import {GroupsAssigneesResponse, instanceOfGroupsAssigneesResponse, GroupsAssigneesResponseFromJSON} from './models'; 
                
export const GroupsAssigneesResponseSchema: any = {
    type: 'object',
    required: [
        'agencies',
        'pccs',
        'agents',
        'status',
    ],
    properties: {
        agencies: {
            type: 'array',
            items: {
                type: 'object',
                properties: {
                    id: {
                        type: 'integer',
                        format: 'int64',
                    },
                    name: {
                        type: 'string',
                    },
                    location: {
                        type: 'object',
                        properties: {
                            country: {
                                type: 'string',
                            },
                            countryCode: {
                                type: 'string',
                            },
                            state: {
                                type: 'string',
                            },
                            city: {
                                type: 'string',
                            },
                            street: {
                                type: 'string',
                            },
                        },
                        required: [
                            'country',
                            'countryCode',
                        ],
                    },
                    groups: {
                        type: 'array',
                        items: {
                            type: 'object',
                            required: [
                                'id',
                                'name',
                            ],
                            properties: {
                                id: {
                                    type: 'integer',
                                    format: 'int64',
                                },
                                name: {
                                    type: 'string',
                                },
                                description: {
                                    type: 'string',
                                },
                                totalAgents: {
                                    type: 'integer',
                                },
                                editorName: {
                                    type: 'string',
                                },
                                applicationType: {
                                    type: 'string',
                                },
                                platformAccess: {
                                    type: 'string',
                                    description: 'Explicit Agency Workspace platform access. DESKTOP_ONLY disables web access and clears the desktop block. WEB_ONLY enables web access and the Desktop_Disabled role. DESKTOP_WEB enables web access and clears the desktop block. When applicationType is supplied, application settings are replaced on create and update, and omitting platformAccess removes platform overrides. An empty applicationType clears application settings. A null or omitted applicationType leaves application settings unchanged.\n',
                                    enum: [
                                        'DESKTOP_ONLY',
                                        'WEB_ONLY',
                                        'DESKTOP_WEB',
                                    ],
                                },
                                welcomeScreen: {
                                    type: 'string',
                                },
                                holdReservation: {
                                    type: 'string',
                                },
                            },
                        },
                    },
                },
                required: [
                    'id',
                    'name',
                ],
            },
        },
        pccs: {
            type: 'array',
            items: {
                type: 'object',
                properties: {
                    id: {
                        type: 'integer',
                        format: 'int64',
                    },
                    pcc: {
                        type: 'string',
                    },
                    sccode: {
                        type: 'string',
                    },
                    agencyName: {
                        type: 'string',
                    },
                    location: {
                        type: 'object',
                        properties: {
                            country: {
                                type: 'string',
                            },
                            countryCode: {
                                type: 'string',
                            },
                            state: {
                                type: 'string',
                            },
                            city: {
                                type: 'string',
                            },
                            street: {
                                type: 'string',
                            },
                        },
                        required: [
                            'country',
                            'countryCode',
                        ],
                    },
                    agency: {
                        type: 'object',
                        properties: {
                            id: {
                                type: 'integer',
                                format: 'int64',
                            },
                            name: {
                                type: 'string',
                            },
                            location: {
                                type: 'object',
                                properties: {
                                    country: {
                                        type: 'string',
                                    },
                                    countryCode: {
                                        type: 'string',
                                    },
                                    state: {
                                        type: 'string',
                                    },
                                    city: {
                                        type: 'string',
                                    },
                                    street: {
                                        type: 'string',
                                    },
                                },
                                required: [
                                    'country',
                                    'countryCode',
                                ],
                            },
                            groups: {
                                type: 'array',
                                items: {
                                    type: 'object',
                                    required: [
                                        'id',
                                        'name',
                                    ],
                                    properties: {
                                        id: {
                                            type: 'integer',
                                            format: 'int64',
                                        },
                                        name: {
                                            type: 'string',
                                        },
                                        description: {
                                            type: 'string',
                                        },
                                        totalAgents: {
                                            type: 'integer',
                                        },
                                        editorName: {
                                            type: 'string',
                                        },
                                        applicationType: {
                                            type: 'string',
                                        },
                                        platformAccess: {
                                            type: 'string',
                                            description: 'Explicit Agency Workspace platform access. DESKTOP_ONLY disables web access and clears the desktop block. WEB_ONLY enables web access and the Desktop_Disabled role. DESKTOP_WEB enables web access and clears the desktop block. When applicationType is supplied, application settings are replaced on create and update, and omitting platformAccess removes platform overrides. An empty applicationType clears application settings. A null or omitted applicationType leaves application settings unchanged.\n',
                                            enum: [
                                                'DESKTOP_ONLY',
                                                'WEB_ONLY',
                                                'DESKTOP_WEB',
                                            ],
                                        },
                                        welcomeScreen: {
                                            type: 'string',
                                        },
                                        holdReservation: {
                                            type: 'string',
                                        },
                                    },
                                },
                            },
                        },
                        required: [
                            'id',
                            'name',
                        ],
                    },
                    groups: {
                        type: 'array',
                        items: {
                            type: 'object',
                            required: [
                                'id',
                                'name',
                            ],
                            properties: {
                                id: {
                                    type: 'integer',
                                    format: 'int64',
                                },
                                name: {
                                    type: 'string',
                                },
                                description: {
                                    type: 'string',
                                },
                                totalAgents: {
                                    type: 'integer',
                                },
                                editorName: {
                                    type: 'string',
                                },
                                applicationType: {
                                    type: 'string',
                                },
                                platformAccess: {
                                    type: 'string',
                                    description: 'Explicit Agency Workspace platform access. DESKTOP_ONLY disables web access and clears the desktop block. WEB_ONLY enables web access and the Desktop_Disabled role. DESKTOP_WEB enables web access and clears the desktop block. When applicationType is supplied, application settings are replaced on create and update, and omitting platformAccess removes platform overrides. An empty applicationType clears application settings. A null or omitted applicationType leaves application settings unchanged.\n',
                                    enum: [
                                        'DESKTOP_ONLY',
                                        'WEB_ONLY',
                                        'DESKTOP_WEB',
                                    ],
                                },
                                welcomeScreen: {
                                    type: 'string',
                                },
                                holdReservation: {
                                    type: 'string',
                                },
                            },
                        },
                    },
                },
                required: [
                    'id',
                    'pcc',
                ],
            },
        },
        agents: {
            type: 'array',
            items: {
                type: 'object',
                properties: {
                    id: {
                        type: 'integer',
                        format: 'int64',
                    },
                    sabreId: {
                        type: 'string',
                    },
                    name: {
                        type: 'string',
                    },
                    pcc: {
                        type: 'object',
                        properties: {
                            id: {
                                type: 'integer',
                                format: 'int64',
                            },
                            pcc: {
                                type: 'string',
                            },
                            sccode: {
                                type: 'string',
                            },
                            agencyName: {
                                type: 'string',
                            },
                            location: {
                                type: 'object',
                                properties: {
                                    country: {
                                        type: 'string',
                                    },
                                    countryCode: {
                                        type: 'string',
                                    },
                                    state: {
                                        type: 'string',
                                    },
                                    city: {
                                        type: 'string',
                                    },
                                    street: {
                                        type: 'string',
                                    },
                                },
                                required: [
                                    'country',
                                    'countryCode',
                                ],
                            },
                            agency: {
                                type: 'object',
                                properties: {
                                    id: {
                                        type: 'integer',
                                        format: 'int64',
                                    },
                                    name: {
                                        type: 'string',
                                    },
                                    location: {
                                        type: 'object',
                                        properties: {
                                            country: {
                                                type: 'string',
                                            },
                                            countryCode: {
                                                type: 'string',
                                            },
                                            state: {
                                                type: 'string',
                                            },
                                            city: {
                                                type: 'string',
                                            },
                                            street: {
                                                type: 'string',
                                            },
                                        },
                                        required: [
                                            'country',
                                            'countryCode',
                                        ],
                                    },
                                    groups: {
                                        type: 'array',
                                        items: {
                                            type: 'object',
                                            required: [
                                                'id',
                                                'name',
                                            ],
                                            properties: {
                                                id: {
                                                    type: 'integer',
                                                    format: 'int64',
                                                },
                                                name: {
                                                    type: 'string',
                                                },
                                                description: {
                                                    type: 'string',
                                                },
                                                totalAgents: {
                                                    type: 'integer',
                                                },
                                                editorName: {
                                                    type: 'string',
                                                },
                                                applicationType: {
                                                    type: 'string',
                                                },
                                                platformAccess: {
                                                    type: 'string',
                                                    description: 'Explicit Agency Workspace platform access. DESKTOP_ONLY disables web access and clears the desktop block. WEB_ONLY enables web access and the Desktop_Disabled role. DESKTOP_WEB enables web access and clears the desktop block. When applicationType is supplied, application settings are replaced on create and update, and omitting platformAccess removes platform overrides. An empty applicationType clears application settings. A null or omitted applicationType leaves application settings unchanged.\n',
                                                    enum: [
                                                        'DESKTOP_ONLY',
                                                        'WEB_ONLY',
                                                        'DESKTOP_WEB',
                                                    ],
                                                },
                                                welcomeScreen: {
                                                    type: 'string',
                                                },
                                                holdReservation: {
                                                    type: 'string',
                                                },
                                            },
                                        },
                                    },
                                },
                                required: [
                                    'id',
                                    'name',
                                ],
                            },
                            groups: {
                                type: 'array',
                                items: {
                                    type: 'object',
                                    required: [
                                        'id',
                                        'name',
                                    ],
                                    properties: {
                                        id: {
                                            type: 'integer',
                                            format: 'int64',
                                        },
                                        name: {
                                            type: 'string',
                                        },
                                        description: {
                                            type: 'string',
                                        },
                                        totalAgents: {
                                            type: 'integer',
                                        },
                                        editorName: {
                                            type: 'string',
                                        },
                                        applicationType: {
                                            type: 'string',
                                        },
                                        platformAccess: {
                                            type: 'string',
                                            description: 'Explicit Agency Workspace platform access. DESKTOP_ONLY disables web access and clears the desktop block. WEB_ONLY enables web access and the Desktop_Disabled role. DESKTOP_WEB enables web access and clears the desktop block. When applicationType is supplied, application settings are replaced on create and update, and omitting platformAccess removes platform overrides. An empty applicationType clears application settings. A null or omitted applicationType leaves application settings unchanged.\n',
                                            enum: [
                                                'DESKTOP_ONLY',
                                                'WEB_ONLY',
                                                'DESKTOP_WEB',
                                            ],
                                        },
                                        welcomeScreen: {
                                            type: 'string',
                                        },
                                        holdReservation: {
                                            type: 'string',
                                        },
                                    },
                                },
                            },
                        },
                        required: [
                            'id',
                            'pcc',
                        ],
                    },
                    groups: {
                        type: 'array',
                        items: {
                            type: 'object',
                            required: [
                                'id',
                                'name',
                            ],
                            properties: {
                                id: {
                                    type: 'integer',
                                    format: 'int64',
                                },
                                name: {
                                    type: 'string',
                                },
                                description: {
                                    type: 'string',
                                },
                                totalAgents: {
                                    type: 'integer',
                                },
                                editorName: {
                                    type: 'string',
                                },
                                applicationType: {
                                    type: 'string',
                                },
                                platformAccess: {
                                    type: 'string',
                                    description: 'Explicit Agency Workspace platform access. DESKTOP_ONLY disables web access and clears the desktop block. WEB_ONLY enables web access and the Desktop_Disabled role. DESKTOP_WEB enables web access and clears the desktop block. When applicationType is supplied, application settings are replaced on create and update, and omitting platformAccess removes platform overrides. An empty applicationType clears application settings. A null or omitted applicationType leaves application settings unchanged.\n',
                                    enum: [
                                        'DESKTOP_ONLY',
                                        'WEB_ONLY',
                                        'DESKTOP_WEB',
                                    ],
                                },
                                welcomeScreen: {
                                    type: 'string',
                                },
                                holdReservation: {
                                    type: 'string',
                                },
                            },
                        },
                    },
                    locked: {
                        type: 'boolean',
                        description: 'True when the agent is currently locked in CM, either by an agency lock, a Sabre lock or an active blueprint recall.',
                    },
                    lockType: {
                        type: 'string',
                        description: 'Type of the lock currently applied to the agent.',
                        enum: [
                            'AGENCY',
                            'SABRE',
                            'RECALL',
                        ],
                    },
                    lockExpirationDate: {
                        type: 'string',
                        format: 'date-time',
                        description: 'Date the currently active lock expires. Not set for recall locks.',
                    },
                },
                required: [
                    'id',
                    'sabreId',
                    'name',
                ],
            },
        },
        status: {
            type: 'string',
            enum: [
                'SUCCESS',
                'ERROR',
            ],
        },
        statusDescription: {
            type: 'string',
        },
    },
    discriminator: {
        propertyName: 'openApiType',
    },
};       

export const asGroupsAssigneesResponse = generateConverterToRx<GroupsAssigneesResponse>(GroupsAssigneesResponseSchema, 'GroupsAssigneesResponseSchema', GroupsAssigneesResponseFromJSON, instanceOfGroupsAssigneesResponse, 'toCamelCase');
export const asGroupsAssigneesResponseArray = generateArrayConverter<GroupsAssigneesResponse>(asGroupsAssigneesResponse);

export function isGroupsAssigneesResponse(o?: any): o is GroupsAssigneesResponse {
    return isDescribedByJsonSchema(o, GroupsAssigneesResponseSchema, false, false);
}   
export function isPartialGroupsAssigneesResponse(o?: any): o is Partial<GroupsAssigneesResponse> {
    return isPartiallyDescribedByJsonSchema(o, GroupsAssigneesResponseSchema);
}   
            
import {Location, instanceOfLocation, LocationFromJSON} from './models'; 
                
export const LocationSchema: any = {
    type: 'object',
    properties: {
        country: {
            type: 'string',
        },
        countryCode: {
            type: 'string',
        },
        state: {
            type: 'string',
        },
        city: {
            type: 'string',
        },
        street: {
            type: 'string',
        },
    },
    required: [
        'country',
        'countryCode',
    ],
};       

export const asLocation = generateConverterToRx<Location>(LocationSchema, 'LocationSchema', LocationFromJSON, instanceOfLocation, 'toCamelCase');
export const asLocationArray = generateArrayConverter<Location>(asLocation);

export function isLocation(o?: any): o is Location {
    return isDescribedByJsonSchema(o, LocationSchema, false, false);
}   
export function isPartialLocation(o?: any): o is Partial<Location> {
    return isPartiallyDescribedByJsonSchema(o, LocationSchema);
}   
            
import {Pcc, instanceOfPcc, PccFromJSON} from './models'; 
                
export const PccSchema: any = {
    type: 'object',
    properties: {
        id: {
            type: 'integer',
            format: 'int64',
        },
        pcc: {
            type: 'string',
        },
        sccode: {
            type: 'string',
        },
        agencyName: {
            type: 'string',
        },
        location: {
            type: 'object',
            properties: {
                country: {
                    type: 'string',
                },
                countryCode: {
                    type: 'string',
                },
                state: {
                    type: 'string',
                },
                city: {
                    type: 'string',
                },
                street: {
                    type: 'string',
                },
            },
            required: [
                'country',
                'countryCode',
            ],
        },
        agency: {
            type: 'object',
            properties: {
                id: {
                    type: 'integer',
                    format: 'int64',
                },
                name: {
                    type: 'string',
                },
                location: {
                    type: 'object',
                    properties: {
                        country: {
                            type: 'string',
                        },
                        countryCode: {
                            type: 'string',
                        },
                        state: {
                            type: 'string',
                        },
                        city: {
                            type: 'string',
                        },
                        street: {
                            type: 'string',
                        },
                    },
                    required: [
                        'country',
                        'countryCode',
                    ],
                },
                groups: {
                    type: 'array',
                    items: {
                        type: 'object',
                        required: [
                            'id',
                            'name',
                        ],
                        properties: {
                            id: {
                                type: 'integer',
                                format: 'int64',
                            },
                            name: {
                                type: 'string',
                            },
                            description: {
                                type: 'string',
                            },
                            totalAgents: {
                                type: 'integer',
                            },
                            editorName: {
                                type: 'string',
                            },
                            applicationType: {
                                type: 'string',
                            },
                            platformAccess: {
                                type: 'string',
                                description: 'Explicit Agency Workspace platform access. DESKTOP_ONLY disables web access and clears the desktop block. WEB_ONLY enables web access and the Desktop_Disabled role. DESKTOP_WEB enables web access and clears the desktop block. When applicationType is supplied, application settings are replaced on create and update, and omitting platformAccess removes platform overrides. An empty applicationType clears application settings. A null or omitted applicationType leaves application settings unchanged.\n',
                                enum: [
                                    'DESKTOP_ONLY',
                                    'WEB_ONLY',
                                    'DESKTOP_WEB',
                                ],
                            },
                            welcomeScreen: {
                                type: 'string',
                            },
                            holdReservation: {
                                type: 'string',
                            },
                        },
                    },
                },
            },
            required: [
                'id',
                'name',
            ],
        },
        groups: {
            type: 'array',
            items: {
                type: 'object',
                required: [
                    'id',
                    'name',
                ],
                properties: {
                    id: {
                        type: 'integer',
                        format: 'int64',
                    },
                    name: {
                        type: 'string',
                    },
                    description: {
                        type: 'string',
                    },
                    totalAgents: {
                        type: 'integer',
                    },
                    editorName: {
                        type: 'string',
                    },
                    applicationType: {
                        type: 'string',
                    },
                    platformAccess: {
                        type: 'string',
                        description: 'Explicit Agency Workspace platform access. DESKTOP_ONLY disables web access and clears the desktop block. WEB_ONLY enables web access and the Desktop_Disabled role. DESKTOP_WEB enables web access and clears the desktop block. When applicationType is supplied, application settings are replaced on create and update, and omitting platformAccess removes platform overrides. An empty applicationType clears application settings. A null or omitted applicationType leaves application settings unchanged.\n',
                        enum: [
                            'DESKTOP_ONLY',
                            'WEB_ONLY',
                            'DESKTOP_WEB',
                        ],
                    },
                    welcomeScreen: {
                        type: 'string',
                    },
                    holdReservation: {
                        type: 'string',
                    },
                },
            },
        },
    },
    required: [
        'id',
        'pcc',
    ],
};       

export const asPcc = generateConverterToRx<Pcc>(PccSchema, 'PccSchema', PccFromJSON, instanceOfPcc, 'toCamelCase');
export const asPccArray = generateArrayConverter<Pcc>(asPcc);

export function isPcc(o?: any): o is Pcc {
    return isDescribedByJsonSchema(o, PccSchema, false, false);
}   
export function isPartialPcc(o?: any): o is Partial<Pcc> {
    return isPartiallyDescribedByJsonSchema(o, PccSchema);
}   
            
import {BaseGroupRequest, instanceOfBaseGroupRequest, BaseGroupRequestFromJSON} from './models'; 
                
export const BaseGroupRequestSchema: any = {
    type: 'object',
    discriminator: {
        propertyName: 'openApiType',
    },
    properties: {
        group: {
            type: 'object',
            properties: {
                id: {
                    type: 'integer',
                    format: 'int64',
                },
                name: {
                    type: 'string',
                },
                description: {
                    type: 'string',
                },
                totalAgents: {
                    type: 'integer',
                },
                editorName: {
                    type: 'string',
                },
                applicationType: {
                    type: 'string',
                },
                platformAccess: {
                    type: 'string',
                    description: 'Explicit Agency Workspace platform access. DESKTOP_ONLY disables web access and clears the desktop block. WEB_ONLY enables web access and the Desktop_Disabled role. DESKTOP_WEB enables web access and clears the desktop block. When applicationType is supplied, application settings are replaced on create and update, and omitting platformAccess removes platform overrides. An empty applicationType clears application settings. A null or omitted applicationType leaves application settings unchanged.\n',
                    enum: [
                        'DESKTOP_ONLY',
                        'WEB_ONLY',
                        'DESKTOP_WEB',
                    ],
                },
                welcomeScreen: {
                    type: 'string',
                },
                holdReservation: {
                    type: 'string',
                },
            },
        },
        workspace: {
            type: 'array',
            items: {
                type: 'object',
                discriminator: {
                    propertyName: 'openApiType',
                },
                properties: {
                    productId: {
                        type: 'integer',
                        format: 'int64',
                    },
                    redAppConfiguration: {
                        type: 'string',
                    },
                    productEnablement: {
                        type: 'string',
                        enum: [
                            'ON',
                            'OFF',
                            'DEFAULT',
                        ],
                    },
                },
                required: [
                    'productId',
                    'productEnablement',
                ],
            },
        },
        redapps: {
            type: 'array',
            items: {
                type: 'object',
                properties: {
                    redAppPlacement: {
                        type: 'string',
                        enum: [
                            'apps-panel',
                            'sidebar',
                        ],
                    },
                    productId: {
                        type: 'integer',
                        format: 'int64',
                    },
                    redAppConfiguration: {
                        type: 'string',
                    },
                    productEnablement: {
                        type: 'string',
                        enum: [
                            'ON',
                            'OFF',
                            'DEFAULT',
                        ],
                    },
                },
                required: [
                    'redAppPlacement',
                    'productId',
                    'productEnablement',
                ],
                discriminator: {
                    propertyName: 'openApiType',
                },
            },
        },
        workflows: {
            type: 'array',
            items: {
                type: 'object',
                discriminator: {
                    propertyName: 'openApiType',
                },
                properties: {
                    productId: {
                        type: 'integer',
                        format: 'int64',
                    },
                    redAppConfiguration: {
                        type: 'string',
                    },
                    productEnablement: {
                        type: 'string',
                        enum: [
                            'ON',
                            'OFF',
                            'DEFAULT',
                        ],
                    },
                },
                required: [
                    'productId',
                    'productEnablement',
                ],
            },
        },
        properties: {
            type: 'array',
            items: {
                type: 'object',
                discriminator: {
                    propertyName: 'openApiType',
                },
                properties: {
                    propertyId: {
                        type: 'integer',
                        format: 'int64',
                    },
                    overrideValue: {
                        type: 'string',
                    },
                    allowUserOverride: {
                        type: 'boolean',
                    },
                    bigRockName: {
                        type: 'string',
                    },
                    bigRockDestiny: {
                        type: 'array',
                        items: {
                            type: 'string',
                        },
                    },
                },
                required: [
                    'propertyId',
                    'allowUserOverride',
                ],
            },
        },
        bigRockRoleIds: {
            type: 'array',
            items: {
                type: 'integer',
                format: 'int64',
            },
        },
    },
    required: [
        'group',
    ],
};       

export const asBaseGroupRequest = generateConverterToRx<BaseGroupRequest>(BaseGroupRequestSchema, 'BaseGroupRequestSchema', BaseGroupRequestFromJSON, instanceOfBaseGroupRequest, 'toCamelCase');
export const asBaseGroupRequestArray = generateArrayConverter<BaseGroupRequest>(asBaseGroupRequest);

export function isBaseGroupRequest(o?: any): o is BaseGroupRequest {
    return isDescribedByJsonSchema(o, BaseGroupRequestSchema, false, false);
}   
export function isPartialBaseGroupRequest(o?: any): o is Partial<BaseGroupRequest> {
    return isPartiallyDescribedByJsonSchema(o, BaseGroupRequestSchema);
}   
            
import {Group, instanceOfGroup, GroupFromJSON} from './models'; 
                
export const GroupSchema: any = {
    type: 'object',
    required: [
        'id',
        'name',
    ],
    properties: {
        id: {
            type: 'integer',
            format: 'int64',
        },
        name: {
            type: 'string',
        },
        description: {
            type: 'string',
        },
        totalAgents: {
            type: 'integer',
        },
        editorName: {
            type: 'string',
        },
        applicationType: {
            type: 'string',
        },
        platformAccess: {
            type: 'string',
            description: 'Explicit Agency Workspace platform access. DESKTOP_ONLY disables web access and clears the desktop block. WEB_ONLY enables web access and the Desktop_Disabled role. DESKTOP_WEB enables web access and clears the desktop block. When applicationType is supplied, application settings are replaced on create and update, and omitting platformAccess removes platform overrides. An empty applicationType clears application settings. A null or omitted applicationType leaves application settings unchanged.\n',
            enum: [
                'DESKTOP_ONLY',
                'WEB_ONLY',
                'DESKTOP_WEB',
            ],
        },
        welcomeScreen: {
            type: 'string',
        },
        holdReservation: {
            type: 'string',
        },
    },
};       

export const asGroup = generateConverterToRx<Group>(GroupSchema, 'GroupSchema', GroupFromJSON, instanceOfGroup, 'toCamelCase');
export const asGroupArray = generateArrayConverter<Group>(asGroup);

export function isGroup(o?: any): o is Group {
    return isDescribedByJsonSchema(o, GroupSchema, false, false);
}   
export function isPartialGroup(o?: any): o is Partial<Group> {
    return isPartiallyDescribedByJsonSchema(o, GroupSchema);
}   
            
import {GroupConfigurationRequest, instanceOfGroupConfigurationRequest, GroupConfigurationRequestFromJSON} from './models'; 
                
export const GroupConfigurationRequestSchema: any = {
    type: 'object',
    properties: {
        cmGroupIds: {
            type: 'array',
            items: {
                type: 'integer',
                format: 'int64',
            },
        },
        groupId: {
            type: 'integer',
            format: 'int64',
        },
    },
    required: [
        'cmGroupIds',
    ],
};       

export const asGroupConfigurationRequest = generateConverterToRx<GroupConfigurationRequest>(GroupConfigurationRequestSchema, 'GroupConfigurationRequestSchema', GroupConfigurationRequestFromJSON, instanceOfGroupConfigurationRequest, 'toCamelCase');
export const asGroupConfigurationRequestArray = generateArrayConverter<GroupConfigurationRequest>(asGroupConfigurationRequest);

export function isGroupConfigurationRequest(o?: any): o is GroupConfigurationRequest {
    return isDescribedByJsonSchema(o, GroupConfigurationRequestSchema, false, false);
}   
export function isPartialGroupConfigurationRequest(o?: any): o is Partial<GroupConfigurationRequest> {
    return isPartiallyDescribedByJsonSchema(o, GroupConfigurationRequestSchema);
}   
            
import {GroupRequest, instanceOfGroupRequest, GroupRequestFromJSON} from './models'; 
                
export const GroupRequestSchema: any = {
    type: 'object',
    properties: {
        cmGroupIds: {
            type: 'array',
            items: {
                type: 'integer',
                format: 'int64',
            },
        },
        group: {
            type: 'object',
            properties: {
                id: {
                    type: 'integer',
                    format: 'int64',
                },
                name: {
                    type: 'string',
                },
                description: {
                    type: 'string',
                },
                totalAgents: {
                    type: 'integer',
                },
                editorName: {
                    type: 'string',
                },
                applicationType: {
                    type: 'string',
                },
                platformAccess: {
                    type: 'string',
                    description: 'Explicit Agency Workspace platform access. DESKTOP_ONLY disables web access and clears the desktop block. WEB_ONLY enables web access and the Desktop_Disabled role. DESKTOP_WEB enables web access and clears the desktop block. When applicationType is supplied, application settings are replaced on create and update, and omitting platformAccess removes platform overrides. An empty applicationType clears application settings. A null or omitted applicationType leaves application settings unchanged.\n',
                    enum: [
                        'DESKTOP_ONLY',
                        'WEB_ONLY',
                        'DESKTOP_WEB',
                    ],
                },
                welcomeScreen: {
                    type: 'string',
                },
                holdReservation: {
                    type: 'string',
                },
            },
        },
        workspace: {
            type: 'array',
            items: {
                type: 'object',
                discriminator: {
                    propertyName: 'openApiType',
                },
                properties: {
                    productId: {
                        type: 'integer',
                        format: 'int64',
                    },
                    redAppConfiguration: {
                        type: 'string',
                    },
                    productEnablement: {
                        type: 'string',
                        enum: [
                            'ON',
                            'OFF',
                            'DEFAULT',
                        ],
                    },
                },
                required: [
                    'productId',
                    'productEnablement',
                ],
            },
        },
        redapps: {
            type: 'array',
            items: {
                type: 'object',
                properties: {
                    redAppPlacement: {
                        type: 'string',
                        enum: [
                            'apps-panel',
                            'sidebar',
                        ],
                    },
                    productId: {
                        type: 'integer',
                        format: 'int64',
                    },
                    redAppConfiguration: {
                        type: 'string',
                    },
                    productEnablement: {
                        type: 'string',
                        enum: [
                            'ON',
                            'OFF',
                            'DEFAULT',
                        ],
                    },
                },
                required: [
                    'redAppPlacement',
                    'productId',
                    'productEnablement',
                ],
                discriminator: {
                    propertyName: 'openApiType',
                },
            },
        },
        workflows: {
            type: 'array',
            items: {
                type: 'object',
                discriminator: {
                    propertyName: 'openApiType',
                },
                properties: {
                    productId: {
                        type: 'integer',
                        format: 'int64',
                    },
                    redAppConfiguration: {
                        type: 'string',
                    },
                    productEnablement: {
                        type: 'string',
                        enum: [
                            'ON',
                            'OFF',
                            'DEFAULT',
                        ],
                    },
                },
                required: [
                    'productId',
                    'productEnablement',
                ],
            },
        },
        properties: {
            type: 'array',
            items: {
                type: 'object',
                discriminator: {
                    propertyName: 'openApiType',
                },
                properties: {
                    propertyId: {
                        type: 'integer',
                        format: 'int64',
                    },
                    overrideValue: {
                        type: 'string',
                    },
                    allowUserOverride: {
                        type: 'boolean',
                    },
                    bigRockName: {
                        type: 'string',
                    },
                    bigRockDestiny: {
                        type: 'array',
                        items: {
                            type: 'string',
                        },
                    },
                },
                required: [
                    'propertyId',
                    'allowUserOverride',
                ],
            },
        },
        bigRockRoleIds: {
            type: 'array',
            items: {
                type: 'integer',
                format: 'int64',
            },
        },
    },
    discriminator: {
        propertyName: 'openApiType',
    },
    required: [
        'group',
    ],
};       

export const asGroupRequest = generateConverterToRx<GroupRequest>(GroupRequestSchema, 'GroupRequestSchema', GroupRequestFromJSON, instanceOfGroupRequest, 'toCamelCase');
export const asGroupRequestArray = generateArrayConverter<GroupRequest>(asGroupRequest);

export function isGroupRequest(o?: any): o is GroupRequest {
    return isDescribedByJsonSchema(o, GroupRequestSchema, false, false);
}   
export function isPartialGroupRequest(o?: any): o is Partial<GroupRequest> {
    return isPartiallyDescribedByJsonSchema(o, GroupRequestSchema);
}   
            
import {GroupResponse, instanceOfGroupResponse, GroupResponseFromJSON} from './models'; 
                
export const GroupResponseSchema: any = {
    type: 'object',
    required: [
        'group',
        'status',
    ],
    properties: {
        group: {
            type: 'object',
            required: [
                'id',
                'name',
            ],
            properties: {
                id: {
                    type: 'integer',
                    format: 'int64',
                },
                name: {
                    type: 'string',
                },
                description: {
                    type: 'string',
                },
                totalAgents: {
                    type: 'integer',
                },
                editorName: {
                    type: 'string',
                },
                applicationType: {
                    type: 'string',
                },
                platformAccess: {
                    type: 'string',
                    description: 'Explicit Agency Workspace platform access. DESKTOP_ONLY disables web access and clears the desktop block. WEB_ONLY enables web access and the Desktop_Disabled role. DESKTOP_WEB enables web access and clears the desktop block. When applicationType is supplied, application settings are replaced on create and update, and omitting platformAccess removes platform overrides. An empty applicationType clears application settings. A null or omitted applicationType leaves application settings unchanged.\n',
                    enum: [
                        'DESKTOP_ONLY',
                        'WEB_ONLY',
                        'DESKTOP_WEB',
                    ],
                },
                welcomeScreen: {
                    type: 'string',
                },
                holdReservation: {
                    type: 'string',
                },
            },
        },
        workspace: {
            type: 'array',
            items: {
                type: 'object',
                discriminator: {
                    propertyName: 'openApiType',
                },
                properties: {
                    productId: {
                        type: 'integer',
                        format: 'int64',
                    },
                    redAppConfiguration: {
                        type: 'string',
                    },
                    productEnablement: {
                        type: 'string',
                        enum: [
                            'ON',
                            'OFF',
                            'DEFAULT',
                        ],
                    },
                },
                required: [
                    'productId',
                    'productEnablement',
                ],
            },
        },
        properties: {
            type: 'array',
            items: {
                type: 'object',
                discriminator: {
                    propertyName: 'openApiType',
                },
                properties: {
                    propertyId: {
                        type: 'integer',
                        format: 'int64',
                    },
                    overrideValue: {
                        type: 'string',
                    },
                    allowUserOverride: {
                        type: 'boolean',
                    },
                    bigRockName: {
                        type: 'string',
                    },
                    bigRockDestiny: {
                        type: 'array',
                        items: {
                            type: 'string',
                        },
                    },
                },
                required: [
                    'propertyId',
                    'allowUserOverride',
                ],
            },
        },
        workflows: {
            type: 'array',
            items: {
                type: 'object',
                discriminator: {
                    propertyName: 'openApiType',
                },
                properties: {
                    productId: {
                        type: 'integer',
                        format: 'int64',
                    },
                    redAppConfiguration: {
                        type: 'string',
                    },
                    productEnablement: {
                        type: 'string',
                        enum: [
                            'ON',
                            'OFF',
                            'DEFAULT',
                        ],
                    },
                },
                required: [
                    'productId',
                    'productEnablement',
                ],
            },
        },
        redapps: {
            type: 'array',
            items: {
                type: 'object',
                properties: {
                    redAppPlacement: {
                        type: 'string',
                        enum: [
                            'apps-panel',
                            'sidebar',
                        ],
                    },
                    productId: {
                        type: 'integer',
                        format: 'int64',
                    },
                    redAppConfiguration: {
                        type: 'string',
                    },
                    productEnablement: {
                        type: 'string',
                        enum: [
                            'ON',
                            'OFF',
                            'DEFAULT',
                        ],
                    },
                },
                required: [
                    'redAppPlacement',
                    'productId',
                    'productEnablement',
                ],
                discriminator: {
                    propertyName: 'openApiType',
                },
            },
        },
        status: {
            type: 'string',
            enum: [
                'SUCCESS',
                'ERROR',
            ],
        },
        statusDescription: {
            type: 'string',
        },
    },
    discriminator: {
        propertyName: 'openApiType',
    },
};       

export const asGroupResponse = generateConverterToRx<GroupResponse>(GroupResponseSchema, 'GroupResponseSchema', GroupResponseFromJSON, instanceOfGroupResponse, 'toCamelCase');
export const asGroupResponseArray = generateArrayConverter<GroupResponse>(asGroupResponse);

export function isGroupResponse(o?: any): o is GroupResponse {
    return isDescribedByJsonSchema(o, GroupResponseSchema, false, false);
}   
export function isPartialGroupResponse(o?: any): o is Partial<GroupResponse> {
    return isPartiallyDescribedByJsonSchema(o, GroupResponseSchema);
}   
            
import {GroupsResponse, instanceOfGroupsResponse, GroupsResponseFromJSON} from './models'; 
                
export const GroupsResponseSchema: any = {
    type: 'object',
    required: [
        'groups',
        'status',
    ],
    properties: {
        groups: {
            type: 'array',
            items: {
                type: 'object',
                required: [
                    'id',
                    'name',
                ],
                properties: {
                    id: {
                        type: 'integer',
                        format: 'int64',
                    },
                    name: {
                        type: 'string',
                    },
                    description: {
                        type: 'string',
                    },
                    totalAgents: {
                        type: 'integer',
                    },
                    editorName: {
                        type: 'string',
                    },
                    applicationType: {
                        type: 'string',
                    },
                    platformAccess: {
                        type: 'string',
                        description: 'Explicit Agency Workspace platform access. DESKTOP_ONLY disables web access and clears the desktop block. WEB_ONLY enables web access and the Desktop_Disabled role. DESKTOP_WEB enables web access and clears the desktop block. When applicationType is supplied, application settings are replaced on create and update, and omitting platformAccess removes platform overrides. An empty applicationType clears application settings. A null or omitted applicationType leaves application settings unchanged.\n',
                        enum: [
                            'DESKTOP_ONLY',
                            'WEB_ONLY',
                            'DESKTOP_WEB',
                        ],
                    },
                    welcomeScreen: {
                        type: 'string',
                    },
                    holdReservation: {
                        type: 'string',
                    },
                },
            },
        },
        status: {
            type: 'string',
            enum: [
                'SUCCESS',
                'ERROR',
            ],
        },
        statusDescription: {
            type: 'string',
        },
    },
    discriminator: {
        propertyName: 'openApiType',
    },
};       

export const asGroupsResponse = generateConverterToRx<GroupsResponse>(GroupsResponseSchema, 'GroupsResponseSchema', GroupsResponseFromJSON, instanceOfGroupsResponse, 'toCamelCase');
export const asGroupsResponseArray = generateArrayConverter<GroupsResponse>(asGroupsResponse);

export function isGroupsResponse(o?: any): o is GroupsResponse {
    return isDescribedByJsonSchema(o, GroupsResponseSchema, false, false);
}   
export function isPartialGroupsResponse(o?: any): o is Partial<GroupsResponse> {
    return isPartiallyDescribedByJsonSchema(o, GroupsResponseSchema);
}   
            
import {ParentGroup, instanceOfParentGroup, ParentGroupFromJSON} from './models'; 
                
export const ParentGroupSchema: any = {
    type: 'object',
    properties: {
        id: {
            type: 'integer',
            format: 'int64',
        },
        name: {
            type: 'string',
        },
    },
};       

export const asParentGroup = generateConverterToRx<ParentGroup>(ParentGroupSchema, 'ParentGroupSchema', ParentGroupFromJSON, instanceOfParentGroup, 'toCamelCase');
export const asParentGroupArray = generateArrayConverter<ParentGroup>(asParentGroup);

export function isParentGroup(o?: any): o is ParentGroup {
    return isDescribedByJsonSchema(o, ParentGroupSchema, false, false);
}   
export function isPartialParentGroup(o?: any): o is Partial<ParentGroup> {
    return isPartiallyDescribedByJsonSchema(o, ParentGroupSchema);
}   
            
import {ParentGroupResponse, instanceOfParentGroupResponse, ParentGroupResponseFromJSON} from './models'; 
                
export const ParentGroupResponseSchema: any = {
    type: 'object',
    properties: {
        group: {
            type: 'object',
            properties: {
                id: {
                    type: 'integer',
                    format: 'int64',
                },
                name: {
                    type: 'string',
                },
            },
        },
        status: {
            type: 'string',
            enum: [
                'SUCCESS',
                'ERROR',
            ],
        },
        statusDescription: {
            type: 'string',
        },
    },
    discriminator: {
        propertyName: 'openApiType',
    },
    required: [
        'status',
    ],
};       

export const asParentGroupResponse = generateConverterToRx<ParentGroupResponse>(ParentGroupResponseSchema, 'ParentGroupResponseSchema', ParentGroupResponseFromJSON, instanceOfParentGroupResponse, 'toCamelCase');
export const asParentGroupResponseArray = generateArrayConverter<ParentGroupResponse>(asParentGroupResponse);

export function isParentGroupResponse(o?: any): o is ParentGroupResponse {
    return isDescribedByJsonSchema(o, ParentGroupResponseSchema, false, false);
}   
export function isPartialParentGroupResponse(o?: any): o is Partial<ParentGroupResponse> {
    return isPartiallyDescribedByJsonSchema(o, ParentGroupResponseSchema);
}   
            
import {PartialGroup, instanceOfPartialGroup, PartialGroupFromJSON} from './models'; 
                
export const PartialGroupSchema: any = {
    type: 'object',
    properties: {
        id: {
            type: 'integer',
            format: 'int64',
        },
        name: {
            type: 'string',
        },
        description: {
            type: 'string',
        },
        totalAgents: {
            type: 'integer',
        },
        editorName: {
            type: 'string',
        },
        applicationType: {
            type: 'string',
        },
        platformAccess: {
            type: 'string',
            description: 'Explicit Agency Workspace platform access. DESKTOP_ONLY disables web access and clears the desktop block. WEB_ONLY enables web access and the Desktop_Disabled role. DESKTOP_WEB enables web access and clears the desktop block. When applicationType is supplied, application settings are replaced on create and update, and omitting platformAccess removes platform overrides. An empty applicationType clears application settings. A null or omitted applicationType leaves application settings unchanged.\n',
            enum: [
                'DESKTOP_ONLY',
                'WEB_ONLY',
                'DESKTOP_WEB',
            ],
        },
        welcomeScreen: {
            type: 'string',
        },
        holdReservation: {
            type: 'string',
        },
    },
};       

export const asPartialGroup = generateConverterToRx<PartialGroup>(PartialGroupSchema, 'PartialGroupSchema', PartialGroupFromJSON, instanceOfPartialGroup, 'toCamelCase');
export const asPartialGroupArray = generateArrayConverter<PartialGroup>(asPartialGroup);

export function isInstanceOfPartialGroup(o?: any): o is PartialGroup {
    return isDescribedByJsonSchema(o, PartialGroupSchema, false, false);
}   
export function isPartialInstanceOfPartialGroup(o?: any): o is Partial<PartialGroup> {
    return isPartiallyDescribedByJsonSchema(o, PartialGroupSchema);
}   
            
import {GroupParticipantsRequest, instanceOfGroupParticipantsRequest, GroupParticipantsRequestFromJSON} from './models'; 
                
export const GroupParticipantsRequestSchema: any = {
    type: 'object',
    properties: {
        id: {
            type: 'integer',
            format: 'int64',
        },
        searchCriteria: {
            type: 'object',
            properties: {
                pattern: {
                    type: 'string',
                },
                type: {
                    type: 'string',
                    enum: [
                        'PCC',
                        'COUNTRY',
                        'AGENCY_NAME',
                        'SABRE_ID',
                        'AGENT_NAME',
                    ],
                },
                sortBy: {
                    type: 'string',
                    description: 'Name of the field to sort by. Supported values are sabreId, name, location, agencyName, groups, lockStatus, pcc and country. Unsupported values fall back to the default ordering.',
                },
                sortOrder: {
                    type: 'string',
                    enum: [
                        'ASC',
                        'DESC',
                    ],
                    default: 'ASC',
                    description: 'Sort direction applied to the requested sort field.',
                },
            },
        },
    },
};       

export const asGroupParticipantsRequest = generateConverterToRx<GroupParticipantsRequest>(GroupParticipantsRequestSchema, 'GroupParticipantsRequestSchema', GroupParticipantsRequestFromJSON, instanceOfGroupParticipantsRequest, 'toCamelCase');
export const asGroupParticipantsRequestArray = generateArrayConverter<GroupParticipantsRequest>(asGroupParticipantsRequest);

export function isGroupParticipantsRequest(o?: any): o is GroupParticipantsRequest {
    return isDescribedByJsonSchema(o, GroupParticipantsRequestSchema, false, false);
}   
export function isPartialGroupParticipantsRequest(o?: any): o is Partial<GroupParticipantsRequest> {
    return isPartiallyDescribedByJsonSchema(o, GroupParticipantsRequestSchema);
}   
            
import {GroupParticipantsResponse, instanceOfGroupParticipantsResponse, GroupParticipantsResponseFromJSON} from './models'; 
                
export const GroupParticipantsResponseSchema: any = {
    type: 'object',
    properties: {
        i18nLvl: {
            type: 'object',
            properties: {
                id: {
                    type: 'integer',
                    format: 'int64',
                },
                name: {
                    type: 'string',
                },
                location: {
                    type: 'object',
                    properties: {
                        country: {
                            type: 'string',
                        },
                        countryCode: {
                            type: 'string',
                        },
                        state: {
                            type: 'string',
                        },
                        city: {
                            type: 'string',
                        },
                        street: {
                            type: 'string',
                        },
                    },
                    required: [
                        'country',
                        'countryCode',
                    ],
                },
                groups: {
                    type: 'array',
                    items: {
                        type: 'object',
                        required: [
                            'id',
                            'name',
                        ],
                        properties: {
                            id: {
                                type: 'integer',
                                format: 'int64',
                            },
                            name: {
                                type: 'string',
                            },
                            description: {
                                type: 'string',
                            },
                            totalAgents: {
                                type: 'integer',
                            },
                            editorName: {
                                type: 'string',
                            },
                            applicationType: {
                                type: 'string',
                            },
                            platformAccess: {
                                type: 'string',
                                description: 'Explicit Agency Workspace platform access. DESKTOP_ONLY disables web access and clears the desktop block. WEB_ONLY enables web access and the Desktop_Disabled role. DESKTOP_WEB enables web access and clears the desktop block. When applicationType is supplied, application settings are replaced on create and update, and omitting platformAccess removes platform overrides. An empty applicationType clears application settings. A null or omitted applicationType leaves application settings unchanged.\n',
                                enum: [
                                    'DESKTOP_ONLY',
                                    'WEB_ONLY',
                                    'DESKTOP_WEB',
                                ],
                            },
                            welcomeScreen: {
                                type: 'string',
                            },
                            holdReservation: {
                                type: 'string',
                            },
                        },
                    },
                },
            },
            required: [
                'id',
                'name',
            ],
        },
        cntrLvl: {
            type: 'object',
            properties: {
                id: {
                    type: 'integer',
                    format: 'int64',
                },
                name: {
                    type: 'string',
                },
                location: {
                    type: 'object',
                    properties: {
                        country: {
                            type: 'string',
                        },
                        countryCode: {
                            type: 'string',
                        },
                        state: {
                            type: 'string',
                        },
                        city: {
                            type: 'string',
                        },
                        street: {
                            type: 'string',
                        },
                    },
                    required: [
                        'country',
                        'countryCode',
                    ],
                },
                groups: {
                    type: 'array',
                    items: {
                        type: 'object',
                        required: [
                            'id',
                            'name',
                        ],
                        properties: {
                            id: {
                                type: 'integer',
                                format: 'int64',
                            },
                            name: {
                                type: 'string',
                            },
                            description: {
                                type: 'string',
                            },
                            totalAgents: {
                                type: 'integer',
                            },
                            editorName: {
                                type: 'string',
                            },
                            applicationType: {
                                type: 'string',
                            },
                            platformAccess: {
                                type: 'string',
                                description: 'Explicit Agency Workspace platform access. DESKTOP_ONLY disables web access and clears the desktop block. WEB_ONLY enables web access and the Desktop_Disabled role. DESKTOP_WEB enables web access and clears the desktop block. When applicationType is supplied, application settings are replaced on create and update, and omitting platformAccess removes platform overrides. An empty applicationType clears application settings. A null or omitted applicationType leaves application settings unchanged.\n',
                                enum: [
                                    'DESKTOP_ONLY',
                                    'WEB_ONLY',
                                    'DESKTOP_WEB',
                                ],
                            },
                            welcomeScreen: {
                                type: 'string',
                            },
                            holdReservation: {
                                type: 'string',
                            },
                        },
                    },
                },
            },
            required: [
                'id',
                'name',
            ],
        },
        pccLvl: {
            type: 'object',
            properties: {
                id: {
                    type: 'integer',
                    format: 'int64',
                },
                pcc: {
                    type: 'string',
                },
                sccode: {
                    type: 'string',
                },
                agencyName: {
                    type: 'string',
                },
                location: {
                    type: 'object',
                    properties: {
                        country: {
                            type: 'string',
                        },
                        countryCode: {
                            type: 'string',
                        },
                        state: {
                            type: 'string',
                        },
                        city: {
                            type: 'string',
                        },
                        street: {
                            type: 'string',
                        },
                    },
                    required: [
                        'country',
                        'countryCode',
                    ],
                },
                agency: {
                    type: 'object',
                    properties: {
                        id: {
                            type: 'integer',
                            format: 'int64',
                        },
                        name: {
                            type: 'string',
                        },
                        location: {
                            type: 'object',
                            properties: {
                                country: {
                                    type: 'string',
                                },
                                countryCode: {
                                    type: 'string',
                                },
                                state: {
                                    type: 'string',
                                },
                                city: {
                                    type: 'string',
                                },
                                street: {
                                    type: 'string',
                                },
                            },
                            required: [
                                'country',
                                'countryCode',
                            ],
                        },
                        groups: {
                            type: 'array',
                            items: {
                                type: 'object',
                                required: [
                                    'id',
                                    'name',
                                ],
                                properties: {
                                    id: {
                                        type: 'integer',
                                        format: 'int64',
                                    },
                                    name: {
                                        type: 'string',
                                    },
                                    description: {
                                        type: 'string',
                                    },
                                    totalAgents: {
                                        type: 'integer',
                                    },
                                    editorName: {
                                        type: 'string',
                                    },
                                    applicationType: {
                                        type: 'string',
                                    },
                                    platformAccess: {
                                        type: 'string',
                                        description: 'Explicit Agency Workspace platform access. DESKTOP_ONLY disables web access and clears the desktop block. WEB_ONLY enables web access and the Desktop_Disabled role. DESKTOP_WEB enables web access and clears the desktop block. When applicationType is supplied, application settings are replaced on create and update, and omitting platformAccess removes platform overrides. An empty applicationType clears application settings. A null or omitted applicationType leaves application settings unchanged.\n',
                                        enum: [
                                            'DESKTOP_ONLY',
                                            'WEB_ONLY',
                                            'DESKTOP_WEB',
                                        ],
                                    },
                                    welcomeScreen: {
                                        type: 'string',
                                    },
                                    holdReservation: {
                                        type: 'string',
                                    },
                                },
                            },
                        },
                    },
                    required: [
                        'id',
                        'name',
                    ],
                },
                groups: {
                    type: 'array',
                    items: {
                        type: 'object',
                        required: [
                            'id',
                            'name',
                        ],
                        properties: {
                            id: {
                                type: 'integer',
                                format: 'int64',
                            },
                            name: {
                                type: 'string',
                            },
                            description: {
                                type: 'string',
                            },
                            totalAgents: {
                                type: 'integer',
                            },
                            editorName: {
                                type: 'string',
                            },
                            applicationType: {
                                type: 'string',
                            },
                            platformAccess: {
                                type: 'string',
                                description: 'Explicit Agency Workspace platform access. DESKTOP_ONLY disables web access and clears the desktop block. WEB_ONLY enables web access and the Desktop_Disabled role. DESKTOP_WEB enables web access and clears the desktop block. When applicationType is supplied, application settings are replaced on create and update, and omitting platformAccess removes platform overrides. An empty applicationType clears application settings. A null or omitted applicationType leaves application settings unchanged.\n',
                                enum: [
                                    'DESKTOP_ONLY',
                                    'WEB_ONLY',
                                    'DESKTOP_WEB',
                                ],
                            },
                            welcomeScreen: {
                                type: 'string',
                            },
                            holdReservation: {
                                type: 'string',
                            },
                        },
                    },
                },
            },
            required: [
                'id',
                'pcc',
            ],
        },
        cntrNo: {
            type: 'integer',
            format: 'int64',
        },
        pccNo: {
            type: 'integer',
            format: 'int64',
        },
        cntrLst: {
            type: 'array',
            items: {
                type: 'object',
                properties: {
                    id: {
                        type: 'integer',
                        format: 'int64',
                    },
                    name: {
                        type: 'string',
                    },
                    location: {
                        type: 'object',
                        properties: {
                            country: {
                                type: 'string',
                            },
                            countryCode: {
                                type: 'string',
                            },
                            state: {
                                type: 'string',
                            },
                            city: {
                                type: 'string',
                            },
                            street: {
                                type: 'string',
                            },
                        },
                        required: [
                            'country',
                            'countryCode',
                        ],
                    },
                    groups: {
                        type: 'array',
                        items: {
                            type: 'object',
                            required: [
                                'id',
                                'name',
                            ],
                            properties: {
                                id: {
                                    type: 'integer',
                                    format: 'int64',
                                },
                                name: {
                                    type: 'string',
                                },
                                description: {
                                    type: 'string',
                                },
                                totalAgents: {
                                    type: 'integer',
                                },
                                editorName: {
                                    type: 'string',
                                },
                                applicationType: {
                                    type: 'string',
                                },
                                platformAccess: {
                                    type: 'string',
                                    description: 'Explicit Agency Workspace platform access. DESKTOP_ONLY disables web access and clears the desktop block. WEB_ONLY enables web access and the Desktop_Disabled role. DESKTOP_WEB enables web access and clears the desktop block. When applicationType is supplied, application settings are replaced on create and update, and omitting platformAccess removes platform overrides. An empty applicationType clears application settings. A null or omitted applicationType leaves application settings unchanged.\n',
                                    enum: [
                                        'DESKTOP_ONLY',
                                        'WEB_ONLY',
                                        'DESKTOP_WEB',
                                    ],
                                },
                                welcomeScreen: {
                                    type: 'string',
                                },
                                holdReservation: {
                                    type: 'string',
                                },
                            },
                        },
                    },
                },
                required: [
                    'id',
                    'name',
                ],
            },
        },
        pccLst: {
            type: 'array',
            items: {
                type: 'object',
                properties: {
                    id: {
                        type: 'integer',
                        format: 'int64',
                    },
                    pcc: {
                        type: 'string',
                    },
                    sccode: {
                        type: 'string',
                    },
                    agencyName: {
                        type: 'string',
                    },
                    location: {
                        type: 'object',
                        properties: {
                            country: {
                                type: 'string',
                            },
                            countryCode: {
                                type: 'string',
                            },
                            state: {
                                type: 'string',
                            },
                            city: {
                                type: 'string',
                            },
                            street: {
                                type: 'string',
                            },
                        },
                        required: [
                            'country',
                            'countryCode',
                        ],
                    },
                    agency: {
                        type: 'object',
                        properties: {
                            id: {
                                type: 'integer',
                                format: 'int64',
                            },
                            name: {
                                type: 'string',
                            },
                            location: {
                                type: 'object',
                                properties: {
                                    country: {
                                        type: 'string',
                                    },
                                    countryCode: {
                                        type: 'string',
                                    },
                                    state: {
                                        type: 'string',
                                    },
                                    city: {
                                        type: 'string',
                                    },
                                    street: {
                                        type: 'string',
                                    },
                                },
                                required: [
                                    'country',
                                    'countryCode',
                                ],
                            },
                            groups: {
                                type: 'array',
                                items: {
                                    type: 'object',
                                    required: [
                                        'id',
                                        'name',
                                    ],
                                    properties: {
                                        id: {
                                            type: 'integer',
                                            format: 'int64',
                                        },
                                        name: {
                                            type: 'string',
                                        },
                                        description: {
                                            type: 'string',
                                        },
                                        totalAgents: {
                                            type: 'integer',
                                        },
                                        editorName: {
                                            type: 'string',
                                        },
                                        applicationType: {
                                            type: 'string',
                                        },
                                        platformAccess: {
                                            type: 'string',
                                            description: 'Explicit Agency Workspace platform access. DESKTOP_ONLY disables web access and clears the desktop block. WEB_ONLY enables web access and the Desktop_Disabled role. DESKTOP_WEB enables web access and clears the desktop block. When applicationType is supplied, application settings are replaced on create and update, and omitting platformAccess removes platform overrides. An empty applicationType clears application settings. A null or omitted applicationType leaves application settings unchanged.\n',
                                            enum: [
                                                'DESKTOP_ONLY',
                                                'WEB_ONLY',
                                                'DESKTOP_WEB',
                                            ],
                                        },
                                        welcomeScreen: {
                                            type: 'string',
                                        },
                                        holdReservation: {
                                            type: 'string',
                                        },
                                    },
                                },
                            },
                        },
                        required: [
                            'id',
                            'name',
                        ],
                    },
                    groups: {
                        type: 'array',
                        items: {
                            type: 'object',
                            required: [
                                'id',
                                'name',
                            ],
                            properties: {
                                id: {
                                    type: 'integer',
                                    format: 'int64',
                                },
                                name: {
                                    type: 'string',
                                },
                                description: {
                                    type: 'string',
                                },
                                totalAgents: {
                                    type: 'integer',
                                },
                                editorName: {
                                    type: 'string',
                                },
                                applicationType: {
                                    type: 'string',
                                },
                                platformAccess: {
                                    type: 'string',
                                    description: 'Explicit Agency Workspace platform access. DESKTOP_ONLY disables web access and clears the desktop block. WEB_ONLY enables web access and the Desktop_Disabled role. DESKTOP_WEB enables web access and clears the desktop block. When applicationType is supplied, application settings are replaced on create and update, and omitting platformAccess removes platform overrides. An empty applicationType clears application settings. A null or omitted applicationType leaves application settings unchanged.\n',
                                    enum: [
                                        'DESKTOP_ONLY',
                                        'WEB_ONLY',
                                        'DESKTOP_WEB',
                                    ],
                                },
                                welcomeScreen: {
                                    type: 'string',
                                },
                                holdReservation: {
                                    type: 'string',
                                },
                            },
                        },
                    },
                },
                required: [
                    'id',
                    'pcc',
                ],
            },
        },
        agentLst: {
            type: 'array',
            items: {
                type: 'object',
                properties: {
                    id: {
                        type: 'integer',
                        format: 'int64',
                    },
                    sabreId: {
                        type: 'string',
                    },
                    name: {
                        type: 'string',
                    },
                    pcc: {
                        type: 'object',
                        properties: {
                            id: {
                                type: 'integer',
                                format: 'int64',
                            },
                            pcc: {
                                type: 'string',
                            },
                            sccode: {
                                type: 'string',
                            },
                            agencyName: {
                                type: 'string',
                            },
                            location: {
                                type: 'object',
                                properties: {
                                    country: {
                                        type: 'string',
                                    },
                                    countryCode: {
                                        type: 'string',
                                    },
                                    state: {
                                        type: 'string',
                                    },
                                    city: {
                                        type: 'string',
                                    },
                                    street: {
                                        type: 'string',
                                    },
                                },
                                required: [
                                    'country',
                                    'countryCode',
                                ],
                            },
                            agency: {
                                type: 'object',
                                properties: {
                                    id: {
                                        type: 'integer',
                                        format: 'int64',
                                    },
                                    name: {
                                        type: 'string',
                                    },
                                    location: {
                                        type: 'object',
                                        properties: {
                                            country: {
                                                type: 'string',
                                            },
                                            countryCode: {
                                                type: 'string',
                                            },
                                            state: {
                                                type: 'string',
                                            },
                                            city: {
                                                type: 'string',
                                            },
                                            street: {
                                                type: 'string',
                                            },
                                        },
                                        required: [
                                            'country',
                                            'countryCode',
                                        ],
                                    },
                                    groups: {
                                        type: 'array',
                                        items: {
                                            type: 'object',
                                            required: [
                                                'id',
                                                'name',
                                            ],
                                            properties: {
                                                id: {
                                                    type: 'integer',
                                                    format: 'int64',
                                                },
                                                name: {
                                                    type: 'string',
                                                },
                                                description: {
                                                    type: 'string',
                                                },
                                                totalAgents: {
                                                    type: 'integer',
                                                },
                                                editorName: {
                                                    type: 'string',
                                                },
                                                applicationType: {
                                                    type: 'string',
                                                },
                                                platformAccess: {
                                                    type: 'string',
                                                    description: 'Explicit Agency Workspace platform access. DESKTOP_ONLY disables web access and clears the desktop block. WEB_ONLY enables web access and the Desktop_Disabled role. DESKTOP_WEB enables web access and clears the desktop block. When applicationType is supplied, application settings are replaced on create and update, and omitting platformAccess removes platform overrides. An empty applicationType clears application settings. A null or omitted applicationType leaves application settings unchanged.\n',
                                                    enum: [
                                                        'DESKTOP_ONLY',
                                                        'WEB_ONLY',
                                                        'DESKTOP_WEB',
                                                    ],
                                                },
                                                welcomeScreen: {
                                                    type: 'string',
                                                },
                                                holdReservation: {
                                                    type: 'string',
                                                },
                                            },
                                        },
                                    },
                                },
                                required: [
                                    'id',
                                    'name',
                                ],
                            },
                            groups: {
                                type: 'array',
                                items: {
                                    type: 'object',
                                    required: [
                                        'id',
                                        'name',
                                    ],
                                    properties: {
                                        id: {
                                            type: 'integer',
                                            format: 'int64',
                                        },
                                        name: {
                                            type: 'string',
                                        },
                                        description: {
                                            type: 'string',
                                        },
                                        totalAgents: {
                                            type: 'integer',
                                        },
                                        editorName: {
                                            type: 'string',
                                        },
                                        applicationType: {
                                            type: 'string',
                                        },
                                        platformAccess: {
                                            type: 'string',
                                            description: 'Explicit Agency Workspace platform access. DESKTOP_ONLY disables web access and clears the desktop block. WEB_ONLY enables web access and the Desktop_Disabled role. DESKTOP_WEB enables web access and clears the desktop block. When applicationType is supplied, application settings are replaced on create and update, and omitting platformAccess removes platform overrides. An empty applicationType clears application settings. A null or omitted applicationType leaves application settings unchanged.\n',
                                            enum: [
                                                'DESKTOP_ONLY',
                                                'WEB_ONLY',
                                                'DESKTOP_WEB',
                                            ],
                                        },
                                        welcomeScreen: {
                                            type: 'string',
                                        },
                                        holdReservation: {
                                            type: 'string',
                                        },
                                    },
                                },
                            },
                        },
                        required: [
                            'id',
                            'pcc',
                        ],
                    },
                    groups: {
                        type: 'array',
                        items: {
                            type: 'object',
                            required: [
                                'id',
                                'name',
                            ],
                            properties: {
                                id: {
                                    type: 'integer',
                                    format: 'int64',
                                },
                                name: {
                                    type: 'string',
                                },
                                description: {
                                    type: 'string',
                                },
                                totalAgents: {
                                    type: 'integer',
                                },
                                editorName: {
                                    type: 'string',
                                },
                                applicationType: {
                                    type: 'string',
                                },
                                platformAccess: {
                                    type: 'string',
                                    description: 'Explicit Agency Workspace platform access. DESKTOP_ONLY disables web access and clears the desktop block. WEB_ONLY enables web access and the Desktop_Disabled role. DESKTOP_WEB enables web access and clears the desktop block. When applicationType is supplied, application settings are replaced on create and update, and omitting platformAccess removes platform overrides. An empty applicationType clears application settings. A null or omitted applicationType leaves application settings unchanged.\n',
                                    enum: [
                                        'DESKTOP_ONLY',
                                        'WEB_ONLY',
                                        'DESKTOP_WEB',
                                    ],
                                },
                                welcomeScreen: {
                                    type: 'string',
                                },
                                holdReservation: {
                                    type: 'string',
                                },
                            },
                        },
                    },
                    locked: {
                        type: 'boolean',
                        description: 'True when the agent is currently locked in CM, either by an agency lock, a Sabre lock or an active blueprint recall.',
                    },
                    lockType: {
                        type: 'string',
                        description: 'Type of the lock currently applied to the agent.',
                        enum: [
                            'AGENCY',
                            'SABRE',
                            'RECALL',
                        ],
                    },
                    lockExpirationDate: {
                        type: 'string',
                        format: 'date-time',
                        description: 'Date the currently active lock expires. Not set for recall locks.',
                    },
                },
                required: [
                    'id',
                    'sabreId',
                    'name',
                ],
            },
        },
        status: {
            type: 'string',
            enum: [
                'SUCCESS',
                'ERROR',
            ],
        },
        statusDescription: {
            type: 'string',
        },
    },
    discriminator: {
        propertyName: 'openApiType',
    },
    required: [
        'status',
    ],
};       

export const asGroupParticipantsResponse = generateConverterToRx<GroupParticipantsResponse>(GroupParticipantsResponseSchema, 'GroupParticipantsResponseSchema', GroupParticipantsResponseFromJSON, instanceOfGroupParticipantsResponse, 'toCamelCase');
export const asGroupParticipantsResponseArray = generateArrayConverter<GroupParticipantsResponse>(asGroupParticipantsResponse);

export function isGroupParticipantsResponse(o?: any): o is GroupParticipantsResponse {
    return isDescribedByJsonSchema(o, GroupParticipantsResponseSchema, false, false);
}   
export function isPartialGroupParticipantsResponse(o?: any): o is Partial<GroupParticipantsResponse> {
    return isPartiallyDescribedByJsonSchema(o, GroupParticipantsResponseSchema);
}   
            
import {GroupParticipantsSearchCriteria, instanceOfGroupParticipantsSearchCriteria, GroupParticipantsSearchCriteriaFromJSON} from './models'; 
                
export const GroupParticipantsSearchCriteriaSchema: any = {
    type: 'object',
    properties: {
        pattern: {
            type: 'string',
        },
        type: {
            type: 'string',
            enum: [
                'PCC',
                'COUNTRY',
                'AGENCY_NAME',
                'SABRE_ID',
                'AGENT_NAME',
            ],
        },
        sortBy: {
            type: 'string',
            description: 'Name of the field to sort by. Supported values are sabreId, name, location, agencyName, groups, lockStatus, pcc and country. Unsupported values fall back to the default ordering.',
        },
        sortOrder: {
            type: 'string',
            enum: [
                'ASC',
                'DESC',
            ],
            default: 'ASC',
            description: 'Sort direction applied to the requested sort field.',
        },
    },
};       

export const asGroupParticipantsSearchCriteria = generateConverterToRx<GroupParticipantsSearchCriteria>(GroupParticipantsSearchCriteriaSchema, 'GroupParticipantsSearchCriteriaSchema', GroupParticipantsSearchCriteriaFromJSON, instanceOfGroupParticipantsSearchCriteria, 'toCamelCase');
export const asGroupParticipantsSearchCriteriaArray = generateArrayConverter<GroupParticipantsSearchCriteria>(asGroupParticipantsSearchCriteria);

export function isGroupParticipantsSearchCriteria(o?: any): o is GroupParticipantsSearchCriteria {
    return isDescribedByJsonSchema(o, GroupParticipantsSearchCriteriaSchema, false, false);
}   
export function isPartialGroupParticipantsSearchCriteria(o?: any): o is Partial<GroupParticipantsSearchCriteria> {
    return isPartiallyDescribedByJsonSchema(o, GroupParticipantsSearchCriteriaSchema);
}   
            
import {SearchGroup, instanceOfSearchGroup, SearchGroupFromJSON} from './models'; 
                
export const SearchGroupSchema: any = {
    type: 'object',
    properties: {
        id: {
            type: 'integer',
            format: 'int64',
        },
        name: {
            type: 'string',
        },
        parentGroupId: {
            type: 'integer',
            format: 'int64',
        },
    },
};       

export const asSearchGroup = generateConverterToRx<SearchGroup>(SearchGroupSchema, 'SearchGroupSchema', SearchGroupFromJSON, instanceOfSearchGroup, 'toCamelCase');
export const asSearchGroupArray = generateArrayConverter<SearchGroup>(asSearchGroup);

export function isSearchGroup(o?: any): o is SearchGroup {
    return isDescribedByJsonSchema(o, SearchGroupSchema, false, false);
}   
export function isPartialSearchGroup(o?: any): o is Partial<SearchGroup> {
    return isPartiallyDescribedByJsonSchema(o, SearchGroupSchema);
}   
            
import {SearchGroupsRequest, instanceOfSearchGroupsRequest, SearchGroupsRequestFromJSON} from './models'; 
                
export const SearchGroupsRequestSchema: any = {
    type: 'object',
    properties: {
        pattern: {
            type: 'string',
            description: 'The search pattern to filter groups by name',
        },
    },
};       

export const asSearchGroupsRequest = generateConverterToRx<SearchGroupsRequest>(SearchGroupsRequestSchema, 'SearchGroupsRequestSchema', SearchGroupsRequestFromJSON, instanceOfSearchGroupsRequest, 'toCamelCase');
export const asSearchGroupsRequestArray = generateArrayConverter<SearchGroupsRequest>(asSearchGroupsRequest);

export function isSearchGroupsRequest(o?: any): o is SearchGroupsRequest {
    return isDescribedByJsonSchema(o, SearchGroupsRequestSchema, false, false);
}   
export function isPartialSearchGroupsRequest(o?: any): o is Partial<SearchGroupsRequest> {
    return isPartiallyDescribedByJsonSchema(o, SearchGroupsRequestSchema);
}   
            
import {SearchGroupsResponse, instanceOfSearchGroupsResponse, SearchGroupsResponseFromJSON} from './models'; 
                
export const SearchGroupsResponseSchema: any = {
    type: 'object',
    properties: {
        groups: {
            type: 'array',
            items: {
                type: 'object',
                properties: {
                    id: {
                        type: 'integer',
                        format: 'int64',
                    },
                    name: {
                        type: 'string',
                    },
                    parentGroupId: {
                        type: 'integer',
                        format: 'int64',
                    },
                },
            },
        },
        status: {
            type: 'string',
            enum: [
                'SUCCESS',
                'ERROR',
            ],
        },
        statusDescription: {
            type: 'string',
        },
    },
    discriminator: {
        propertyName: 'openApiType',
    },
    required: [
        'status',
    ],
};       

export const asSearchGroupsResponse = generateConverterToRx<SearchGroupsResponse>(SearchGroupsResponseSchema, 'SearchGroupsResponseSchema', SearchGroupsResponseFromJSON, instanceOfSearchGroupsResponse, 'toCamelCase');
export const asSearchGroupsResponseArray = generateArrayConverter<SearchGroupsResponse>(asSearchGroupsResponse);

export function isSearchGroupsResponse(o?: any): o is SearchGroupsResponse {
    return isDescribedByJsonSchema(o, SearchGroupsResponseSchema, false, false);
}   
export function isPartialSearchGroupsResponse(o?: any): o is Partial<SearchGroupsResponse> {
    return isPartiallyDescribedByJsonSchema(o, SearchGroupsResponseSchema);
}   
            
import {ConfigurableProduct, instanceOfConfigurableProduct, ConfigurableProductFromJSON} from './models'; 
                
export const ConfigurableProductSchema: any = {
    type: 'object',
    discriminator: {
        propertyName: 'openApiType',
    },
    properties: {
        productId: {
            type: 'integer',
            format: 'int64',
        },
        redAppConfiguration: {
            type: 'string',
        },
    },
    required: [
        'productId',
    ],
};       

export const asConfigurableProduct = generateConverterToRx<ConfigurableProduct>(ConfigurableProductSchema, 'ConfigurableProductSchema', ConfigurableProductFromJSON, instanceOfConfigurableProduct, 'toCamelCase');
export const asConfigurableProductArray = generateArrayConverter<ConfigurableProduct>(asConfigurableProduct);

export function isConfigurableProduct(o?: any): o is ConfigurableProduct {
    return isDescribedByJsonSchema(o, ConfigurableProductSchema, false, false);
}   
export function isPartialConfigurableProduct(o?: any): o is Partial<ConfigurableProduct> {
    return isPartiallyDescribedByJsonSchema(o, ConfigurableProductSchema);
}   
            
import {EnableProduct, instanceOfEnableProduct, EnableProductFromJSON} from './models'; 
                
export const EnableProductSchema: any = {
    type: 'object',
    properties: {
        productEnablement: {
            type: 'string',
            enum: [
                'ON',
                'OFF',
                'DEFAULT',
            ],
        },
    },
    required: [
        'productEnablement',
    ],
};       

export const asEnableProduct = generateConverterToRx<EnableProduct>(EnableProductSchema, 'EnableProductSchema', EnableProductFromJSON, instanceOfEnableProduct, 'toCamelCase');
export const asEnableProductArray = generateArrayConverter<EnableProduct>(asEnableProduct);

export function isEnableProduct(o?: any): o is EnableProduct {
    return isDescribedByJsonSchema(o, EnableProductSchema, false, false);
}   
export function isPartialEnableProduct(o?: any): o is Partial<EnableProduct> {
    return isPartiallyDescribedByJsonSchema(o, EnableProductSchema);
}   
            
import {GroupInfo, instanceOfGroupInfo, GroupInfoFromJSON} from './models'; 
                
export const GroupInfoSchema: any = {
    type: 'object',
    properties: {
        usingAgentsDetails: {
            type: 'array',
            items: {
                type: 'object',
                properties: {
                    id: {
                        type: 'integer',
                        format: 'int64',
                    },
                    assignee: {
                        type: 'string',
                    },
                    agent: {
                        type: 'string',
                    },
                    level: {
                        type: 'string',
                        enum: [
                            'USER',
                            'PCC',
                            'AGENCY',
                        ],
                    },
                },
                required: [
                    'id',
                    'assignee',
                    'agent',
                    'level',
                ],
            },
        },
    },
};       

export const asGroupInfo = generateConverterToRx<GroupInfo>(GroupInfoSchema, 'GroupInfoSchema', GroupInfoFromJSON, instanceOfGroupInfo, 'toCamelCase');
export const asGroupInfoArray = generateArrayConverter<GroupInfo>(asGroupInfo);

export function isGroupInfo(o?: any): o is GroupInfo {
    return isDescribedByJsonSchema(o, GroupInfoSchema, false, false);
}   
export function isPartialGroupInfo(o?: any): o is Partial<GroupInfo> {
    return isPartiallyDescribedByJsonSchema(o, GroupInfoSchema);
}   
            
import {GroupSettingsIdsReponse, instanceOfGroupSettingsIdsReponse, GroupSettingsIdsReponseFromJSON} from './models'; 
                
export const GroupSettingsIdsReponseSchema: any = {
    type: 'object',
    properties: {
        workspace: {
            type: 'object',
            properties: {
                usingAgentsDetails: {
                    type: 'array',
                    items: {
                        type: 'object',
                        properties: {
                            id: {
                                type: 'integer',
                                format: 'int64',
                            },
                            assignee: {
                                type: 'string',
                            },
                            agent: {
                                type: 'string',
                            },
                            level: {
                                type: 'string',
                                enum: [
                                    'USER',
                                    'PCC',
                                    'AGENCY',
                                ],
                            },
                        },
                        required: [
                            'id',
                            'assignee',
                            'agent',
                            'level',
                        ],
                    },
                },
            },
        },
        status: {
            type: 'string',
            enum: [
                'SUCCESS',
                'ERROR',
            ],
        },
        statusDescription: {
            type: 'string',
        },
    },
    discriminator: {
        propertyName: 'openApiType',
    },
    required: [
        'status',
    ],
};       

export const asGroupSettingsIdsReponse = generateConverterToRx<GroupSettingsIdsReponse>(GroupSettingsIdsReponseSchema, 'GroupSettingsIdsReponseSchema', GroupSettingsIdsReponseFromJSON, instanceOfGroupSettingsIdsReponse, 'toCamelCase');
export const asGroupSettingsIdsReponseArray = generateArrayConverter<GroupSettingsIdsReponse>(asGroupSettingsIdsReponse);

export function isGroupSettingsIdsReponse(o?: any): o is GroupSettingsIdsReponse {
    return isDescribedByJsonSchema(o, GroupSettingsIdsReponseSchema, false, false);
}   
export function isPartialGroupSettingsIdsReponse(o?: any): o is Partial<GroupSettingsIdsReponse> {
    return isPartiallyDescribedByJsonSchema(o, GroupSettingsIdsReponseSchema);
}   
            
import {GroupSettingsResponse, instanceOfGroupSettingsResponse, GroupSettingsResponseFromJSON} from './models'; 
                
export const GroupSettingsResponseSchema: any = {
    type: 'object',
    properties: {
        workspace: {
            type: 'array',
            items: {
                type: 'object',
                properties: {
                    id: {
                        type: 'integer',
                        format: 'int64',
                    },
                    name: {
                        type: 'string',
                    },
                    description: {
                        type: 'string',
                    },
                    totalAgents: {
                        type: 'integer',
                    },
                    usingAgents: {
                        type: 'integer',
                    },
                    productEnablement: {
                        type: 'string',
                        enum: [
                            'ON',
                            'OFF',
                            'DEFAULT',
                        ],
                    },
                    redappPlacement: {
                        type: 'string',
                        enum: [
                            'apps-panel',
                            'sidebar',
                        ],
                    },
                    redappConfiguration: {
                        type: 'string',
                    },
                    iuName: {
                        type: 'string',
                    },
                },
                required: [
                    'id',
                    'name',
                ],
            },
        },
        redApps: {
            type: 'array',
            items: {
                type: 'object',
                properties: {
                    id: {
                        type: 'integer',
                        format: 'int64',
                    },
                    name: {
                        type: 'string',
                    },
                    description: {
                        type: 'string',
                    },
                    totalAgents: {
                        type: 'integer',
                    },
                    usingAgents: {
                        type: 'integer',
                    },
                    productEnablement: {
                        type: 'string',
                        enum: [
                            'ON',
                            'OFF',
                            'DEFAULT',
                        ],
                    },
                    redappPlacement: {
                        type: 'string',
                        enum: [
                            'apps-panel',
                            'sidebar',
                        ],
                    },
                    redappConfiguration: {
                        type: 'string',
                    },
                    iuName: {
                        type: 'string',
                    },
                },
                required: [
                    'id',
                    'name',
                ],
            },
        },
        properties: {
            type: 'array',
            items: {
                type: 'object',
                properties: {
                    id: {
                        type: 'integer',
                        format: 'int64',
                    },
                    name: {
                        type: 'string',
                    },
                    description: {
                        type: 'string',
                    },
                    overrideValue: {
                        type: 'string',
                    },
                    possibleValues: {
                        type: 'object',
                    },
                    additionalProperties: {
                        type: 'string',
                    },
                    allowUserOverride: {
                        type: 'boolean',
                    },
                },
                required: [
                    'id',
                ],
            },
        },
        status: {
            type: 'string',
            enum: [
                'SUCCESS',
                'ERROR',
            ],
        },
        statusDescription: {
            type: 'string',
        },
    },
    discriminator: {
        propertyName: 'openApiType',
    },
    required: [
        'status',
    ],
};       

export const asGroupSettingsResponse = generateConverterToRx<GroupSettingsResponse>(GroupSettingsResponseSchema, 'GroupSettingsResponseSchema', GroupSettingsResponseFromJSON, instanceOfGroupSettingsResponse, 'toCamelCase');
export const asGroupSettingsResponseArray = generateArrayConverter<GroupSettingsResponse>(asGroupSettingsResponse);

export function isGroupSettingsResponse(o?: any): o is GroupSettingsResponse {
    return isDescribedByJsonSchema(o, GroupSettingsResponseSchema, false, false);
}   
export function isPartialGroupSettingsResponse(o?: any): o is Partial<GroupSettingsResponse> {
    return isPartiallyDescribedByJsonSchema(o, GroupSettingsResponseSchema);
}   
            
import {Property, instanceOfProperty, PropertyFromJSON} from './models'; 
                
export const PropertySchema: any = {
    type: 'object',
    properties: {
        id: {
            type: 'integer',
            format: 'int64',
        },
        name: {
            type: 'string',
        },
        description: {
            type: 'string',
        },
        overrideValue: {
            type: 'string',
        },
        possibleValues: {
            type: 'object',
        },
        additionalProperties: {
            type: 'string',
        },
        allowUserOverride: {
            type: 'boolean',
        },
    },
    required: [
        'id',
    ],
};       

export const asProperty = generateConverterToRx<Property>(PropertySchema, 'PropertySchema', PropertyFromJSON, instanceOfProperty, 'toCamelCase');
export const asPropertyArray = generateArrayConverter<Property>(asProperty);

export function isProperty(o?: any): o is Property {
    return isDescribedByJsonSchema(o, PropertySchema, false, false);
}   
export function isPartialProperty(o?: any): o is Partial<Property> {
    return isPartiallyDescribedByJsonSchema(o, PropertySchema);
}   
            
import {PropertyUpdate, instanceOfPropertyUpdate, PropertyUpdateFromJSON} from './models'; 
                
export const PropertyUpdateSchema: any = {
    type: 'object',
    discriminator: {
        propertyName: 'openApiType',
    },
    properties: {
        propertyId: {
            type: 'integer',
            format: 'int64',
        },
        overrideValue: {
            type: 'string',
        },
        allowUserOverride: {
            type: 'boolean',
        },
        bigRockName: {
            type: 'string',
        },
        bigRockDestiny: {
            type: 'array',
            items: {
                type: 'string',
            },
        },
    },
    required: [
        'propertyId',
        'allowUserOverride',
    ],
};       

export const asPropertyUpdate = generateConverterToRx<PropertyUpdate>(PropertyUpdateSchema, 'PropertyUpdateSchema', PropertyUpdateFromJSON, instanceOfPropertyUpdate, 'toCamelCase');
export const asPropertyUpdateArray = generateArrayConverter<PropertyUpdate>(asPropertyUpdate);

export function isPropertyUpdate(o?: any): o is PropertyUpdate {
    return isDescribedByJsonSchema(o, PropertyUpdateSchema, false, false);
}   
export function isPartialPropertyUpdate(o?: any): o is Partial<PropertyUpdate> {
    return isPartiallyDescribedByJsonSchema(o, PropertyUpdateSchema);
}   
            
import {RedAppPlacementSetting, instanceOfRedAppPlacementSetting, RedAppPlacementSettingFromJSON} from './models'; 
                
export const RedAppPlacementSettingSchema: any = {
    type: 'object',
    properties: {
        redAppPlacement: {
            type: 'string',
            enum: [
                'apps-panel',
                'sidebar',
            ],
        },
        productId: {
            type: 'integer',
            format: 'int64',
        },
        redAppConfiguration: {
            type: 'string',
        },
        productEnablement: {
            type: 'string',
            enum: [
                'ON',
                'OFF',
                'DEFAULT',
            ],
        },
    },
    required: [
        'redAppPlacement',
        'productId',
        'productEnablement',
    ],
    discriminator: {
        propertyName: 'openApiType',
    },
};       

export const asRedAppPlacementSetting = generateConverterToRx<RedAppPlacementSetting>(RedAppPlacementSettingSchema, 'RedAppPlacementSettingSchema', RedAppPlacementSettingFromJSON, instanceOfRedAppPlacementSetting, 'toCamelCase');
export const asRedAppPlacementSettingArray = generateArrayConverter<RedAppPlacementSetting>(asRedAppPlacementSetting);

export function isRedAppPlacementSetting(o?: any): o is RedAppPlacementSetting {
    return isDescribedByJsonSchema(o, RedAppPlacementSettingSchema, false, false);
}   
export function isPartialRedAppPlacementSetting(o?: any): o is Partial<RedAppPlacementSetting> {
    return isPartiallyDescribedByJsonSchema(o, RedAppPlacementSettingSchema);
}   
            
import {WorkflowEnablement, instanceOfWorkflowEnablement, WorkflowEnablementFromJSON} from './models'; 
                
export const WorkflowEnablementSchema: any = {
    type: 'object',
    discriminator: {
        propertyName: 'openApiType',
    },
    properties: {
        productId: {
            type: 'integer',
            format: 'int64',
        },
        redAppConfiguration: {
            type: 'string',
        },
        productEnablement: {
            type: 'string',
            enum: [
                'ON',
                'OFF',
                'DEFAULT',
            ],
        },
    },
    required: [
        'productId',
        'productEnablement',
    ],
};       

export const asWorkflowEnablement = generateConverterToRx<WorkflowEnablement>(WorkflowEnablementSchema, 'WorkflowEnablementSchema', WorkflowEnablementFromJSON, instanceOfWorkflowEnablement, 'toCamelCase');
export const asWorkflowEnablementArray = generateArrayConverter<WorkflowEnablement>(asWorkflowEnablement);

export function isWorkflowEnablement(o?: any): o is WorkflowEnablement {
    return isDescribedByJsonSchema(o, WorkflowEnablementSchema, false, false);
}   
export function isPartialWorkflowEnablement(o?: any): o is Partial<WorkflowEnablement> {
    return isPartiallyDescribedByJsonSchema(o, WorkflowEnablementSchema);
}   
            
import {Workspace, instanceOfWorkspace, WorkspaceFromJSON} from './models'; 
                
export const WorkspaceSchema: any = {
    type: 'object',
    properties: {
        id: {
            type: 'integer',
            format: 'int64',
        },
        name: {
            type: 'string',
        },
        description: {
            type: 'string',
        },
        totalAgents: {
            type: 'integer',
        },
        usingAgents: {
            type: 'integer',
        },
        productEnablement: {
            type: 'string',
            enum: [
                'ON',
                'OFF',
                'DEFAULT',
            ],
        },
        redappPlacement: {
            type: 'string',
            enum: [
                'apps-panel',
                'sidebar',
            ],
        },
        redappConfiguration: {
            type: 'string',
        },
        iuName: {
            type: 'string',
        },
    },
    required: [
        'id',
        'name',
    ],
};       

export const asWorkspace = generateConverterToRx<Workspace>(WorkspaceSchema, 'WorkspaceSchema', WorkspaceFromJSON, instanceOfWorkspace, 'toCamelCase');
export const asWorkspaceArray = generateArrayConverter<Workspace>(asWorkspace);

export function isWorkspace(o?: any): o is Workspace {
    return isDescribedByJsonSchema(o, WorkspaceSchema, false, false);
}   
export function isPartialWorkspace(o?: any): o is Partial<Workspace> {
    return isPartiallyDescribedByJsonSchema(o, WorkspaceSchema);
}   
            
import {WorkspaceEnablement, instanceOfWorkspaceEnablement, WorkspaceEnablementFromJSON} from './models'; 
                
export const WorkspaceEnablementSchema: any = {
    type: 'object',
    discriminator: {
        propertyName: 'openApiType',
    },
    properties: {
        productId: {
            type: 'integer',
            format: 'int64',
        },
        redAppConfiguration: {
            type: 'string',
        },
        productEnablement: {
            type: 'string',
            enum: [
                'ON',
                'OFF',
                'DEFAULT',
            ],
        },
    },
    required: [
        'productId',
        'productEnablement',
    ],
};       

export const asWorkspaceEnablement = generateConverterToRx<WorkspaceEnablement>(WorkspaceEnablementSchema, 'WorkspaceEnablementSchema', WorkspaceEnablementFromJSON, instanceOfWorkspaceEnablement, 'toCamelCase');
export const asWorkspaceEnablementArray = generateArrayConverter<WorkspaceEnablement>(asWorkspaceEnablement);

export function isWorkspaceEnablement(o?: any): o is WorkspaceEnablement {
    return isDescribedByJsonSchema(o, WorkspaceEnablementSchema, false, false);
}   
export function isPartialWorkspaceEnablement(o?: any): o is Partial<WorkspaceEnablement> {
    return isPartiallyDescribedByJsonSchema(o, WorkspaceEnablementSchema);
}   
            
import {UpdateGroupRequest, instanceOfUpdateGroupRequest, UpdateGroupRequestFromJSON} from './models'; 
                
export const UpdateGroupRequestSchema: any = {
    type: 'object',
    properties: {
        addedCmGroupIds: {
            type: 'array',
            items: {
                type: 'integer',
                format: 'int64',
            },
        },
        removedCmGroupIds: {
            type: 'array',
            items: {
                type: 'integer',
                format: 'int64',
            },
        },
        group: {
            type: 'object',
            properties: {
                id: {
                    type: 'integer',
                    format: 'int64',
                },
                name: {
                    type: 'string',
                },
                description: {
                    type: 'string',
                },
                totalAgents: {
                    type: 'integer',
                },
                editorName: {
                    type: 'string',
                },
                applicationType: {
                    type: 'string',
                },
                platformAccess: {
                    type: 'string',
                    description: 'Explicit Agency Workspace platform access. DESKTOP_ONLY disables web access and clears the desktop block. WEB_ONLY enables web access and the Desktop_Disabled role. DESKTOP_WEB enables web access and clears the desktop block. When applicationType is supplied, application settings are replaced on create and update, and omitting platformAccess removes platform overrides. An empty applicationType clears application settings. A null or omitted applicationType leaves application settings unchanged.\n',
                    enum: [
                        'DESKTOP_ONLY',
                        'WEB_ONLY',
                        'DESKTOP_WEB',
                    ],
                },
                welcomeScreen: {
                    type: 'string',
                },
                holdReservation: {
                    type: 'string',
                },
            },
        },
        workspace: {
            type: 'array',
            items: {
                type: 'object',
                discriminator: {
                    propertyName: 'openApiType',
                },
                properties: {
                    productId: {
                        type: 'integer',
                        format: 'int64',
                    },
                    redAppConfiguration: {
                        type: 'string',
                    },
                    productEnablement: {
                        type: 'string',
                        enum: [
                            'ON',
                            'OFF',
                            'DEFAULT',
                        ],
                    },
                },
                required: [
                    'productId',
                    'productEnablement',
                ],
            },
        },
        redapps: {
            type: 'array',
            items: {
                type: 'object',
                properties: {
                    redAppPlacement: {
                        type: 'string',
                        enum: [
                            'apps-panel',
                            'sidebar',
                        ],
                    },
                    productId: {
                        type: 'integer',
                        format: 'int64',
                    },
                    redAppConfiguration: {
                        type: 'string',
                    },
                    productEnablement: {
                        type: 'string',
                        enum: [
                            'ON',
                            'OFF',
                            'DEFAULT',
                        ],
                    },
                },
                required: [
                    'redAppPlacement',
                    'productId',
                    'productEnablement',
                ],
                discriminator: {
                    propertyName: 'openApiType',
                },
            },
        },
        workflows: {
            type: 'array',
            items: {
                type: 'object',
                discriminator: {
                    propertyName: 'openApiType',
                },
                properties: {
                    productId: {
                        type: 'integer',
                        format: 'int64',
                    },
                    redAppConfiguration: {
                        type: 'string',
                    },
                    productEnablement: {
                        type: 'string',
                        enum: [
                            'ON',
                            'OFF',
                            'DEFAULT',
                        ],
                    },
                },
                required: [
                    'productId',
                    'productEnablement',
                ],
            },
        },
        properties: {
            type: 'array',
            items: {
                type: 'object',
                discriminator: {
                    propertyName: 'openApiType',
                },
                properties: {
                    propertyId: {
                        type: 'integer',
                        format: 'int64',
                    },
                    overrideValue: {
                        type: 'string',
                    },
                    allowUserOverride: {
                        type: 'boolean',
                    },
                    bigRockName: {
                        type: 'string',
                    },
                    bigRockDestiny: {
                        type: 'array',
                        items: {
                            type: 'string',
                        },
                    },
                },
                required: [
                    'propertyId',
                    'allowUserOverride',
                ],
            },
        },
        bigRockRoleIds: {
            type: 'array',
            items: {
                type: 'integer',
                format: 'int64',
            },
        },
    },
    discriminator: {
        propertyName: 'openApiType',
    },
    required: [
        'group',
    ],
};       

export const asUpdateGroupRequest = generateConverterToRx<UpdateGroupRequest>(UpdateGroupRequestSchema, 'UpdateGroupRequestSchema', UpdateGroupRequestFromJSON, instanceOfUpdateGroupRequest, 'toCamelCase');
export const asUpdateGroupRequestArray = generateArrayConverter<UpdateGroupRequest>(asUpdateGroupRequest);

export function isUpdateGroupRequest(o?: any): o is UpdateGroupRequest {
    return isDescribedByJsonSchema(o, UpdateGroupRequestSchema, false, false);
}   
export function isPartialUpdateGroupRequest(o?: any): o is Partial<UpdateGroupRequest> {
    return isPartiallyDescribedByJsonSchema(o, UpdateGroupRequestSchema);
}   
            
import {HistoryEntry, instanceOfHistoryEntry, HistoryEntryFromJSON} from './models'; 
                
export const HistoryEntrySchema: any = {
    type: 'object',
    description: 'Single row of the "View history of group and setting changes" report, matching the columns known from the desktop admin tool.',
    required: [
        'dateTime',
        'editedById',
        'editedByName',
        'changeType',
    ],
    properties: {
        dateTime: {
            type: 'string',
            description: 'Moment the change was recorded, as an ISO-8601 timestamp with the time zone offset. Kept as a plain string so it is presented exactly as returned, without any client side time zone conversion.',
        },
        editedById: {
            type: 'string',
            description: 'Sabre id (PCC_EPR) of the admin who made the change.',
        },
        editedByName: {
            type: 'string',
            description: 'Name of the admin who made the change.',
        },
        changeType: {
            type: 'string',
            description: 'Operation type, e.g. CREATE, UPDATE, DELETE, ASSIGN, UNASSIGN.',
        },
        groupName: {
            type: 'string',
            description: 'Name of the affected group.',
        },
        agentName: {
            type: 'string',
            description: 'Name of the agent assigned to or unassigned from the group.',
        },
        agentId: {
            type: 'string',
            description: 'Sabre id (PCC_EPR) of the affected agent.',
        },
        productName: {
            type: 'string',
            description: 'Name of the affected product.',
        },
        newSetting: {
            type: 'string',
            description: 'New value of the changed product setting.',
        },
    },
};       

export const asHistoryEntry = generateConverterToRx<HistoryEntry>(HistoryEntrySchema, 'HistoryEntrySchema', HistoryEntryFromJSON, instanceOfHistoryEntry, 'toCamelCase');
export const asHistoryEntryArray = generateArrayConverter<HistoryEntry>(asHistoryEntry);

export function isHistoryEntry(o?: any): o is HistoryEntry {
    return isDescribedByJsonSchema(o, HistoryEntrySchema, false, false);
}   
export function isPartialHistoryEntry(o?: any): o is Partial<HistoryEntry> {
    return isPartiallyDescribedByJsonSchema(o, HistoryEntrySchema);
}   
            
import {HistoryResponse, instanceOfHistoryResponse, HistoryResponseFromJSON} from './models'; 
                
export const HistoryResponseSchema: any = {
    type: 'object',
    required: [
        'historyEntries',
        'page',
        'pageSize',
        'totalRecords',
        'status',
    ],
    properties: {
        historyEntries: {
            type: 'array',
            items: {
                type: 'object',
                description: 'Single row of the "View history of group and setting changes" report, matching the columns known from the desktop admin tool.',
                required: [
                    'dateTime',
                    'editedById',
                    'editedByName',
                    'changeType',
                ],
                properties: {
                    dateTime: {
                        type: 'string',
                        description: 'Moment the change was recorded, as an ISO-8601 timestamp with the time zone offset. Kept as a plain string so it is presented exactly as returned, without any client side time zone conversion.',
                    },
                    editedById: {
                        type: 'string',
                        description: 'Sabre id (PCC_EPR) of the admin who made the change.',
                    },
                    editedByName: {
                        type: 'string',
                        description: 'Name of the admin who made the change.',
                    },
                    changeType: {
                        type: 'string',
                        description: 'Operation type, e.g. CREATE, UPDATE, DELETE, ASSIGN, UNASSIGN.',
                    },
                    groupName: {
                        type: 'string',
                        description: 'Name of the affected group.',
                    },
                    agentName: {
                        type: 'string',
                        description: 'Name of the agent assigned to or unassigned from the group.',
                    },
                    agentId: {
                        type: 'string',
                        description: 'Sabre id (PCC_EPR) of the affected agent.',
                    },
                    productName: {
                        type: 'string',
                        description: 'Name of the affected product.',
                    },
                    newSetting: {
                        type: 'string',
                        description: 'New value of the changed product setting.',
                    },
                },
            },
        },
        page: {
            type: 'integer',
            format: 'int32',
            minimum: 0,
        },
        pageSize: {
            type: 'integer',
            format: 'int32',
            minimum: 1,
        },
        totalRecords: {
            type: 'integer',
            format: 'int64',
            minimum: 0,
        },
        status: {
            type: 'string',
            enum: [
                'SUCCESS',
                'ERROR',
            ],
        },
        statusDescription: {
            type: 'string',
        },
    },
    discriminator: {
        propertyName: 'openApiType',
    },
};       

export const asHistoryResponse = generateConverterToRx<HistoryResponse>(HistoryResponseSchema, 'HistoryResponseSchema', HistoryResponseFromJSON, instanceOfHistoryResponse, 'toCamelCase');
export const asHistoryResponseArray = generateArrayConverter<HistoryResponse>(asHistoryResponse);

export function isHistoryResponse(o?: any): o is HistoryResponse {
    return isDescribedByJsonSchema(o, HistoryResponseSchema, false, false);
}   
export function isPartialHistoryResponse(o?: any): o is Partial<HistoryResponse> {
    return isPartiallyDescribedByJsonSchema(o, HistoryResponseSchema);
}   
            
import {PagedResponse, instanceOfPagedResponse, PagedResponseFromJSON} from './models'; 
                
export const PagedResponseSchema: any = {
    type: 'object',
    properties: {
        page: {
            type: 'integer',
            format: 'int32',
            minimum: 0,
        },
        pageSize: {
            type: 'integer',
            format: 'int32',
            minimum: 1,
        },
        totalRecords: {
            type: 'integer',
            format: 'int64',
            minimum: 0,
        },
        status: {
            type: 'string',
            enum: [
                'SUCCESS',
                'ERROR',
            ],
        },
        statusDescription: {
            type: 'string',
        },
    },
    required: [
        'page',
        'pageSize',
        'totalRecords',
        'status',
    ],
    discriminator: {
        propertyName: 'openApiType',
    },
};       

export const asPagedResponse = generateConverterToRx<PagedResponse>(PagedResponseSchema, 'PagedResponseSchema', PagedResponseFromJSON, instanceOfPagedResponse, 'toCamelCase');
export const asPagedResponseArray = generateArrayConverter<PagedResponse>(asPagedResponse);

export function isPagedResponse(o?: any): o is PagedResponse {
    return isDescribedByJsonSchema(o, PagedResponseSchema, false, false);
}   
export function isPartialPagedResponse(o?: any): o is Partial<PagedResponse> {
    return isPartiallyDescribedByJsonSchema(o, PagedResponseSchema);
}   
            
import {PageRequest, instanceOfPageRequest, PageRequestFromJSON} from './models'; 
                
export const PageRequestSchema: any = {
    type: 'object',
    properties: {
        page: {
            type: 'integer',
            format: 'int32',
            minimum: 0,
            default: 0,
            description: 'Zero-based page index.',
        },
        pageSize: {
            type: 'integer',
            format: 'int32',
            minimum: 1,
            default: 10,
            description: 'Requested records per page. The server caps this value at 100.',
        },
        sortBy: {
            type: 'string',
            description: 'Name of the field to sort by. Allowed values depend on the endpoint and unsupported values fall back to the default ordering.',
        },
        sortOrder: {
            type: 'string',
            enum: [
                'ASC',
                'DESC',
            ],
            default: 'ASC',
            description: 'Sort direction applied to the requested sort field.',
        },
    },
    required: [
        'page',
        'pageSize',
    ],
};       

export const asPageRequest = generateConverterToRx<PageRequest>(PageRequestSchema, 'PageRequestSchema', PageRequestFromJSON, instanceOfPageRequest, 'toCamelCase');
export const asPageRequestArray = generateArrayConverter<PageRequest>(asPageRequest);

export function isPageRequest(o?: any): o is PageRequest {
    return isDescribedByJsonSchema(o, PageRequestSchema, false, false);
}   
export function isPartialPageRequest(o?: any): o is Partial<PageRequest> {
    return isPartiallyDescribedByJsonSchema(o, PageRequestSchema);
}   
            
import {Product, instanceOfProduct, ProductFromJSON} from './models'; 
                
export const ProductSchema: any = {
    type: 'object',
    properties: {
        iuName: {
            type: 'string',
        },
        iuVersion: {
            type: 'string',
        },
        hidden: {
            type: 'boolean',
        },
        marktgFeature: {
            type: 'boolean',
        },
        critical: {
            type: 'boolean',
        },
        iceAttributes: {
            type: 'string',
        },
        updateSiteId: {
            type: 'integer',
            format: 'int64',
        },
        langsCollection: {
            type: 'array',
            items: {
                type: 'string',
            },
        },
        updatesiteVersion: {
            type: 'string',
        },
        authorId: {
            type: 'integer',
            format: 'int64',
        },
        productAttributes: {
            type: 'array',
            items: {
                type: 'object',
                properties: {
                    key: {
                        type: 'string',
                    },
                    isChecked: {
                        type: 'string',
                    },
                    id: {
                        type: 'integer',
                        format: 'int64',
                    },
                    name: {
                        type: 'string',
                    },
                    notes: {
                        type: 'string',
                    },
                },
                required: [],
            },
        },
        id: {
            type: 'integer',
            format: 'int64',
        },
        name: {
            type: 'string',
        },
        notes: {
            type: 'string',
        },
    },
    required: [],
};       

export const asProduct = generateConverterToRx<Product>(ProductSchema, 'ProductSchema', ProductFromJSON, instanceOfProduct, 'toCamelCase');
export const asProductArray = generateArrayConverter<Product>(asProduct);

export function isProduct(o?: any): o is Product {
    return isDescribedByJsonSchema(o, ProductSchema, false, false);
}   
export function isPartialProduct(o?: any): o is Partial<Product> {
    return isPartiallyDescribedByJsonSchema(o, ProductSchema);
}   
            
import {ProductAttribute, instanceOfProductAttribute, ProductAttributeFromJSON} from './models'; 
                
export const ProductAttributeSchema: any = {
    type: 'object',
    properties: {
        key: {
            type: 'string',
        },
        isChecked: {
            type: 'string',
        },
        id: {
            type: 'integer',
            format: 'int64',
        },
        name: {
            type: 'string',
        },
        notes: {
            type: 'string',
        },
    },
    required: [],
};       

export const asProductAttribute = generateConverterToRx<ProductAttribute>(ProductAttributeSchema, 'ProductAttributeSchema', ProductAttributeFromJSON, instanceOfProductAttribute, 'toCamelCase');
export const asProductAttributeArray = generateArrayConverter<ProductAttribute>(asProductAttribute);

export function isProductAttribute(o?: any): o is ProductAttribute {
    return isDescribedByJsonSchema(o, ProductAttributeSchema, false, false);
}   
export function isPartialProductAttribute(o?: any): o is Partial<ProductAttribute> {
    return isPartiallyDescribedByJsonSchema(o, ProductAttributeSchema);
}   
            
import {ProductResponse, instanceOfProductResponse, ProductResponseFromJSON} from './models'; 
                
export const ProductResponseSchema: any = {
    type: 'object',
    properties: {
        product: {
            type: 'object',
            properties: {
                iuName: {
                    type: 'string',
                },
                iuVersion: {
                    type: 'string',
                },
                hidden: {
                    type: 'boolean',
                },
                marktgFeature: {
                    type: 'boolean',
                },
                critical: {
                    type: 'boolean',
                },
                iceAttributes: {
                    type: 'string',
                },
                updateSiteId: {
                    type: 'integer',
                    format: 'int64',
                },
                langsCollection: {
                    type: 'array',
                    items: {
                        type: 'string',
                    },
                },
                updatesiteVersion: {
                    type: 'string',
                },
                authorId: {
                    type: 'integer',
                    format: 'int64',
                },
                productAttributes: {
                    type: 'array',
                    items: {
                        type: 'object',
                        properties: {
                            key: {
                                type: 'string',
                            },
                            isChecked: {
                                type: 'string',
                            },
                            id: {
                                type: 'integer',
                                format: 'int64',
                            },
                            name: {
                                type: 'string',
                            },
                            notes: {
                                type: 'string',
                            },
                        },
                        required: [],
                    },
                },
                id: {
                    type: 'integer',
                    format: 'int64',
                },
                name: {
                    type: 'string',
                },
                notes: {
                    type: 'string',
                },
            },
            required: [],
        },
        status: {
            type: 'string',
            enum: [
                'SUCCESS',
                'ERROR',
            ],
        },
        statusDescription: {
            type: 'string',
        },
    },
    discriminator: {
        propertyName: 'openApiType',
    },
    required: [
        'status',
    ],
};       

export const asProductResponse = generateConverterToRx<ProductResponse>(ProductResponseSchema, 'ProductResponseSchema', ProductResponseFromJSON, instanceOfProductResponse, 'toCamelCase');
export const asProductResponseArray = generateArrayConverter<ProductResponse>(asProductResponse);

export function isProductResponse(o?: any): o is ProductResponse {
    return isDescribedByJsonSchema(o, ProductResponseSchema, false, false);
}   
export function isPartialProductResponse(o?: any): o is Partial<ProductResponse> {
    return isPartiallyDescribedByJsonSchema(o, ProductResponseSchema);
}   
            
import {SearchProductsRequest, instanceOfSearchProductsRequest, SearchProductsRequestFromJSON} from './models'; 
                
export const SearchProductsRequestSchema: any = {
    type: 'object',
    properties: {
        pattern: {
            type: 'string',
        },
    },
    required: [
        'pattern',
    ],
};       

export const asSearchProductsRequest = generateConverterToRx<SearchProductsRequest>(SearchProductsRequestSchema, 'SearchProductsRequestSchema', SearchProductsRequestFromJSON, instanceOfSearchProductsRequest, 'toCamelCase');
export const asSearchProductsRequestArray = generateArrayConverter<SearchProductsRequest>(asSearchProductsRequest);

export function isSearchProductsRequest(o?: any): o is SearchProductsRequest {
    return isDescribedByJsonSchema(o, SearchProductsRequestSchema, false, false);
}   
export function isPartialSearchProductsRequest(o?: any): o is Partial<SearchProductsRequest> {
    return isPartiallyDescribedByJsonSchema(o, SearchProductsRequestSchema);
}   
            
import {RedApp, instanceOfRedApp, RedAppFromJSON} from './models'; 
                
export const RedAppSchema: any = {
    type: 'object',
    required: [
        'name',
        'iu_name',
    ],
    properties: {
        name: {
            type: 'string',
        },
        iuName: {
            type: 'string',
        },
        isRedapp: {
            type: 'boolean',
        },
    },
};       

export const asRedApp = generateConverterToRx<RedApp>(RedAppSchema, 'RedAppSchema', RedAppFromJSON, instanceOfRedApp, 'toCamelCase');
export const asRedAppArray = generateArrayConverter<RedApp>(asRedApp);

export function isRedApp(o?: any): o is RedApp {
    return isDescribedByJsonSchema(o, RedAppSchema, false, false);
}   
export function isPartialRedApp(o?: any): o is Partial<RedApp> {
    return isPartiallyDescribedByJsonSchema(o, RedAppSchema);
}   
            
import {RedAppResponse, instanceOfRedAppResponse, RedAppResponseFromJSON} from './models'; 
                
export const RedAppResponseSchema: any = {
    type: 'object',
    required: [
        'redApps',
        'status',
    ],
    properties: {
        redApps: {
            type: 'array',
            items: {
                type: 'object',
                required: [
                    'name',
                    'iu_name',
                ],
                properties: {
                    name: {
                        type: 'string',
                    },
                    iu_name: {
                        type: 'string',
                    },
                    is_redapp: {
                        type: 'boolean',
                    },
                },
            },
        },
        status: {
            type: 'string',
            enum: [
                'SUCCESS',
                'ERROR',
            ],
        },
        statusDescription: {
            type: 'string',
        },
    },
    discriminator: {
        propertyName: 'openApiType',
    },
};       

export const asRedAppResponse = generateConverterToRx<RedAppResponse>(RedAppResponseSchema, 'RedAppResponseSchema', RedAppResponseFromJSON, instanceOfRedAppResponse, 'toCamelCase');
export const asRedAppResponseArray = generateArrayConverter<RedAppResponse>(asRedAppResponse);

export function isRedAppResponse(o?: any): o is RedAppResponse {
    return isDescribedByJsonSchema(o, RedAppResponseSchema, false, false);
}   
export function isPartialRedAppResponse(o?: any): o is Partial<RedAppResponse> {
    return isPartiallyDescribedByJsonSchema(o, RedAppResponseSchema);
}   
            
import {RedAppWhiteListRequest, instanceOfRedAppWhiteListRequest, RedAppWhiteListRequestFromJSON} from './models'; 
                
export const RedAppWhiteListRequestSchema: any = {
    type: 'object',
    required: [
        'redAppId',
    ],
    properties: {
        redAppId: {
            type: 'string',
        },
    },
};       

export const asRedAppWhiteListRequest = generateConverterToRx<RedAppWhiteListRequest>(RedAppWhiteListRequestSchema, 'RedAppWhiteListRequestSchema', RedAppWhiteListRequestFromJSON, instanceOfRedAppWhiteListRequest, 'toCamelCase');
export const asRedAppWhiteListRequestArray = generateArrayConverter<RedAppWhiteListRequest>(asRedAppWhiteListRequest);

export function isRedAppWhiteListRequest(o?: any): o is RedAppWhiteListRequest {
    return isDescribedByJsonSchema(o, RedAppWhiteListRequestSchema, false, false);
}   
export function isPartialRedAppWhiteListRequest(o?: any): o is Partial<RedAppWhiteListRequest> {
    return isPartiallyDescribedByJsonSchema(o, RedAppWhiteListRequestSchema);
}   
            
import {RedAppWhiteListResponse, instanceOfRedAppWhiteListResponse, RedAppWhiteListResponseFromJSON} from './models'; 
                
export const RedAppWhiteListResponseSchema: any = {
    type: 'object',
    required: [
        'redApps',
        'status',
    ],
    properties: {
        redApps: {
            type: 'array',
            items: {
                type: 'string',
            },
        },
        status: {
            type: 'string',
            enum: [
                'SUCCESS',
                'ERROR',
            ],
        },
        statusDescription: {
            type: 'string',
        },
    },
    discriminator: {
        propertyName: 'openApiType',
    },
};       

export const asRedAppWhiteListResponse = generateConverterToRx<RedAppWhiteListResponse>(RedAppWhiteListResponseSchema, 'RedAppWhiteListResponseSchema', RedAppWhiteListResponseFromJSON, instanceOfRedAppWhiteListResponse, 'toCamelCase');
export const asRedAppWhiteListResponseArray = generateArrayConverter<RedAppWhiteListResponse>(asRedAppWhiteListResponse);

export function isRedAppWhiteListResponse(o?: any): o is RedAppWhiteListResponse {
    return isDescribedByJsonSchema(o, RedAppWhiteListResponseSchema, false, false);
}   
export function isPartialRedAppWhiteListResponse(o?: any): o is Partial<RedAppWhiteListResponse> {
    return isPartiallyDescribedByJsonSchema(o, RedAppWhiteListResponseSchema);
}   
            
import {GetRoleResponse, instanceOfGetRoleResponse, GetRoleResponseFromJSON} from './models'; 
                
export const GetRoleResponseSchema: any = {
    type: 'object',
    properties: {
        role: {
            type: 'object',
            properties: {
                parentRoles: {
                    type: 'array',
                    items: {
                        type: 'object',
                        properties: {
                            name: {
                                type: 'string',
                            },
                            id: {
                                type: 'integer',
                                format: 'int64',
                            },
                            enabled: {
                                type: 'boolean',
                            },
                        },
                        required: [
                            'name',
                        ],
                    },
                },
                configItems: {
                    type: 'array',
                    items: {
                        type: 'object',
                        properties: {
                            id: {
                                type: 'integer',
                                format: 'int64',
                            },
                            notes: {
                                type: 'string',
                            },
                            value: {
                                type: 'string',
                            },
                            levelLocked: {
                                type: 'boolean',
                            },
                            allowUserOverride: {
                                type: 'boolean',
                            },
                            relatedProductName: {
                                type: 'string',
                                maxLength: 240,
                            },
                            roleId: {
                                type: 'integer',
                                format: 'int64',
                            },
                            productId: {
                                type: 'integer',
                                format: 'int64',
                            },
                            propertyId: {
                                type: 'integer',
                                format: 'int64',
                            },
                        },
                    },
                },
                id: {
                    type: 'integer',
                    format: 'int64',
                },
                name: {
                    type: 'string',
                },
                notes: {
                    type: 'string',
                },
            },
            required: [
                'parentRoles',
                'id',
                'name',
            ],
        },
        status: {
            type: 'string',
            enum: [
                'SUCCESS',
                'ERROR',
            ],
        },
        statusDescription: {
            type: 'string',
        },
    },
    required: [
        'role',
        'status',
    ],
    discriminator: {
        propertyName: 'openApiType',
    },
};       

export const asGetRoleResponse = generateConverterToRx<GetRoleResponse>(GetRoleResponseSchema, 'GetRoleResponseSchema', GetRoleResponseFromJSON, instanceOfGetRoleResponse, 'toCamelCase');
export const asGetRoleResponseArray = generateArrayConverter<GetRoleResponse>(asGetRoleResponse);

export function isGetRoleResponse(o?: any): o is GetRoleResponse {
    return isDescribedByJsonSchema(o, GetRoleResponseSchema, false, false);
}   
export function isPartialGetRoleResponse(o?: any): o is Partial<GetRoleResponse> {
    return isPartiallyDescribedByJsonSchema(o, GetRoleResponseSchema);
}   
            
import {ParentRole, instanceOfParentRole, ParentRoleFromJSON} from './models'; 
                
export const ParentRoleSchema: any = {
    type: 'object',
    properties: {
        name: {
            type: 'string',
        },
        id: {
            type: 'integer',
            format: 'int64',
        },
        enabled: {
            type: 'boolean',
        },
    },
    required: [
        'name',
    ],
};       

export const asParentRole = generateConverterToRx<ParentRole>(ParentRoleSchema, 'ParentRoleSchema', ParentRoleFromJSON, instanceOfParentRole, 'toCamelCase');
export const asParentRoleArray = generateArrayConverter<ParentRole>(asParentRole);

export function isParentRole(o?: any): o is ParentRole {
    return isDescribedByJsonSchema(o, ParentRoleSchema, false, false);
}   
export function isPartialParentRole(o?: any): o is Partial<ParentRole> {
    return isPartiallyDescribedByJsonSchema(o, ParentRoleSchema);
}   
            
import {ParentRoleAssociationRequest, instanceOfParentRoleAssociationRequest, ParentRoleAssociationRequestFromJSON} from './models'; 
                
export const ParentRoleAssociationRequestSchema: any = {
    type: 'object',
    properties: {
        parentRoles: {
            type: 'array',
            items: {
                type: 'object',
                properties: {
                    id: {
                        type: 'integer',
                        format: 'int64',
                    },
                    enabled: {
                        type: 'boolean',
                    },
                },
            },
            minItems: 1,
        },
    },
    required: [
        'parentRoles',
    ],
};       

export const asParentRoleAssociationRequest = generateConverterToRx<ParentRoleAssociationRequest>(ParentRoleAssociationRequestSchema, 'ParentRoleAssociationRequestSchema', ParentRoleAssociationRequestFromJSON, instanceOfParentRoleAssociationRequest, 'toCamelCase');
export const asParentRoleAssociationRequestArray = generateArrayConverter<ParentRoleAssociationRequest>(asParentRoleAssociationRequest);

export function isParentRoleAssociationRequest(o?: any): o is ParentRoleAssociationRequest {
    return isDescribedByJsonSchema(o, ParentRoleAssociationRequestSchema, false, false);
}   
export function isPartialParentRoleAssociationRequest(o?: any): o is Partial<ParentRoleAssociationRequest> {
    return isPartiallyDescribedByJsonSchema(o, ParentRoleAssociationRequestSchema);
}   
            
import {ParentRoleBatchRemoveRequest, instanceOfParentRoleBatchRemoveRequest, ParentRoleBatchRemoveRequestFromJSON} from './models'; 
                
export const ParentRoleBatchRemoveRequestSchema: any = {
    type: 'object',
    properties: {
        parentRoleIds: {
            type: 'array',
            items: {
                type: 'integer',
                format: 'int64',
            },
            minItems: 1,
        },
    },
    required: [
        'parentRoleIds',
    ],
};       

export const asParentRoleBatchRemoveRequest = generateConverterToRx<ParentRoleBatchRemoveRequest>(ParentRoleBatchRemoveRequestSchema, 'ParentRoleBatchRemoveRequestSchema', ParentRoleBatchRemoveRequestFromJSON, instanceOfParentRoleBatchRemoveRequest, 'toCamelCase');
export const asParentRoleBatchRemoveRequestArray = generateArrayConverter<ParentRoleBatchRemoveRequest>(asParentRoleBatchRemoveRequest);

export function isParentRoleBatchRemoveRequest(o?: any): o is ParentRoleBatchRemoveRequest {
    return isDescribedByJsonSchema(o, ParentRoleBatchRemoveRequestSchema, false, false);
}   
export function isPartialParentRoleBatchRemoveRequest(o?: any): o is Partial<ParentRoleBatchRemoveRequest> {
    return isPartiallyDescribedByJsonSchema(o, ParentRoleBatchRemoveRequestSchema);
}   
            
import {ParentRoleEnabledRequest, instanceOfParentRoleEnabledRequest, ParentRoleEnabledRequestFromJSON} from './models'; 
                
export const ParentRoleEnabledRequestSchema: any = {
    type: 'object',
    properties: {
        parentRoleIds: {
            type: 'array',
            items: {
                type: 'integer',
                format: 'int64',
            },
            minItems: 1,
        },
        enabled: {
            type: 'boolean',
        },
    },
    required: [
        'parentRoleIds',
        'enabled',
    ],
};       

export const asParentRoleEnabledRequest = generateConverterToRx<ParentRoleEnabledRequest>(ParentRoleEnabledRequestSchema, 'ParentRoleEnabledRequestSchema', ParentRoleEnabledRequestFromJSON, instanceOfParentRoleEnabledRequest, 'toCamelCase');
export const asParentRoleEnabledRequestArray = generateArrayConverter<ParentRoleEnabledRequest>(asParentRoleEnabledRequest);

export function isParentRoleEnabledRequest(o?: any): o is ParentRoleEnabledRequest {
    return isDescribedByJsonSchema(o, ParentRoleEnabledRequestSchema, false, false);
}   
export function isPartialParentRoleEnabledRequest(o?: any): o is Partial<ParentRoleEnabledRequest> {
    return isPartiallyDescribedByJsonSchema(o, ParentRoleEnabledRequestSchema);
}   
            
import {ParentRoleSearchRequest, instanceOfParentRoleSearchRequest, ParentRoleSearchRequestFromJSON} from './models'; 
                
export const ParentRoleSearchRequestSchema: any = {
    type: 'object',
    properties: {
        page: {
            type: 'integer',
            format: 'int32',
            minimum: 0,
            default: 0,
            description: 'Zero-based page index.',
        },
        pageSize: {
            type: 'integer',
            format: 'int32',
            minimum: 1,
            default: 10,
            description: 'Requested records per page. The server caps this value at 100.',
        },
        sortBy: {
            type: 'string',
            description: 'Name of the field to sort by. Allowed values depend on the endpoint and unsupported values fall back to the default ordering.',
        },
        sortOrder: {
            type: 'string',
            enum: [
                'ASC',
                'DESC',
            ],
            default: 'ASC',
            description: 'Sort direction applied to the requested sort field.',
        },
    },
    required: [
        'page',
        'pageSize',
    ],
};       

export const asParentRoleSearchRequest = generateConverterToRx<ParentRoleSearchRequest>(ParentRoleSearchRequestSchema, 'ParentRoleSearchRequestSchema', ParentRoleSearchRequestFromJSON, instanceOfParentRoleSearchRequest, 'toCamelCase');
export const asParentRoleSearchRequestArray = generateArrayConverter<ParentRoleSearchRequest>(asParentRoleSearchRequest);

export function isParentRoleSearchRequest(o?: any): o is ParentRoleSearchRequest {
    return isDescribedByJsonSchema(o, ParentRoleSearchRequestSchema, false, false);
}   
export function isPartialParentRoleSearchRequest(o?: any): o is Partial<ParentRoleSearchRequest> {
    return isPartiallyDescribedByJsonSchema(o, ParentRoleSearchRequestSchema);
}   
            
import {ParentRoleSearchResponse, instanceOfParentRoleSearchResponse, ParentRoleSearchResponseFromJSON} from './models'; 
                
export const ParentRoleSearchResponseSchema: any = {
    type: 'object',
    properties: {
        roles: {
            type: 'array',
            items: {
                type: 'object',
                properties: {
                    name: {
                        type: 'string',
                    },
                    id: {
                        type: 'integer',
                        format: 'int64',
                    },
                    enabled: {
                        type: 'boolean',
                    },
                },
                required: [
                    'name',
                ],
            },
        },
        page: {
            type: 'integer',
            format: 'int32',
            minimum: 0,
        },
        pageSize: {
            type: 'integer',
            format: 'int32',
            minimum: 1,
        },
        totalRecords: {
            type: 'integer',
            format: 'int64',
            minimum: 0,
        },
        status: {
            type: 'string',
            enum: [
                'SUCCESS',
                'ERROR',
            ],
        },
        statusDescription: {
            type: 'string',
        },
    },
    required: [
        'roles',
        'page',
        'pageSize',
        'totalRecords',
        'status',
    ],
    discriminator: {
        propertyName: 'openApiType',
    },
};       

export const asParentRoleSearchResponse = generateConverterToRx<ParentRoleSearchResponse>(ParentRoleSearchResponseSchema, 'ParentRoleSearchResponseSchema', ParentRoleSearchResponseFromJSON, instanceOfParentRoleSearchResponse, 'toCamelCase');
export const asParentRoleSearchResponseArray = generateArrayConverter<ParentRoleSearchResponse>(asParentRoleSearchResponse);

export function isParentRoleSearchResponse(o?: any): o is ParentRoleSearchResponse {
    return isDescribedByJsonSchema(o, ParentRoleSearchResponseSchema, false, false);
}   
export function isPartialParentRoleSearchResponse(o?: any): o is Partial<ParentRoleSearchResponse> {
    return isPartiallyDescribedByJsonSchema(o, ParentRoleSearchResponseSchema);
}   
            
import {PartialParentRole, instanceOfPartialParentRole, PartialParentRoleFromJSON} from './models'; 
                
export const PartialParentRoleSchema: any = {
    type: 'object',
    properties: {
        id: {
            type: 'integer',
            format: 'int64',
        },
        enabled: {
            type: 'boolean',
        },
    },
};       

export const asPartialParentRole = generateConverterToRx<PartialParentRole>(PartialParentRoleSchema, 'PartialParentRoleSchema', PartialParentRoleFromJSON, instanceOfPartialParentRole, 'toCamelCase');
export const asPartialParentRoleArray = generateArrayConverter<PartialParentRole>(asPartialParentRole);

export function isInstanceOfPartialParentRole(o?: any): o is PartialParentRole {
    return isDescribedByJsonSchema(o, PartialParentRoleSchema, false, false);
}   
export function isPartialInstanceOfPartialParentRole(o?: any): o is Partial<PartialParentRole> {
    return isPartiallyDescribedByJsonSchema(o, PartialParentRoleSchema);
}   
            
import {PartialRole, instanceOfPartialRole, PartialRoleFromJSON} from './models'; 
                
export const PartialRoleSchema: any = {
    type: 'object',
    properties: {
        id: {
            type: 'integer',
            format: 'int64',
        },
        name: {
            type: 'string',
        },
        notes: {
            type: 'string',
        },
    },
};       

export const asPartialRole = generateConverterToRx<PartialRole>(PartialRoleSchema, 'PartialRoleSchema', PartialRoleFromJSON, instanceOfPartialRole, 'toCamelCase');
export const asPartialRoleArray = generateArrayConverter<PartialRole>(asPartialRole);

export function isInstanceOfPartialRole(o?: any): o is PartialRole {
    return isDescribedByJsonSchema(o, PartialRoleSchema, false, false);
}   
export function isPartialInstanceOfPartialRole(o?: any): o is Partial<PartialRole> {
    return isPartiallyDescribedByJsonSchema(o, PartialRoleSchema);
}   
            
import {Role, instanceOfRole, RoleFromJSON} from './models'; 
                
export const RoleSchema: any = {
    type: 'object',
    properties: {
        parentRoles: {
            type: 'array',
            items: {
                type: 'object',
                properties: {
                    name: {
                        type: 'string',
                    },
                    id: {
                        type: 'integer',
                        format: 'int64',
                    },
                    enabled: {
                        type: 'boolean',
                    },
                },
                required: [
                    'name',
                ],
            },
        },
        configItems: {
            type: 'array',
            items: {
                type: 'object',
                properties: {
                    id: {
                        type: 'integer',
                        format: 'int64',
                    },
                    notes: {
                        type: 'string',
                    },
                    value: {
                        type: 'string',
                    },
                    levelLocked: {
                        type: 'boolean',
                    },
                    allowUserOverride: {
                        type: 'boolean',
                    },
                    relatedProductName: {
                        type: 'string',
                        maxLength: 240,
                    },
                    roleId: {
                        type: 'integer',
                        format: 'int64',
                    },
                    productId: {
                        type: 'integer',
                        format: 'int64',
                    },
                    propertyId: {
                        type: 'integer',
                        format: 'int64',
                    },
                },
            },
        },
        id: {
            type: 'integer',
            format: 'int64',
        },
        name: {
            type: 'string',
        },
        notes: {
            type: 'string',
        },
    },
    required: [
        'parentRoles',
        'id',
        'name',
    ],
};       

export const asRole = generateConverterToRx<Role>(RoleSchema, 'RoleSchema', RoleFromJSON, instanceOfRole, 'toCamelCase');
export const asRoleArray = generateArrayConverter<Role>(asRole);

export function isRole(o?: any): o is Role {
    return isDescribedByJsonSchema(o, RoleSchema, false, false);
}   
export function isPartialRole(o?: any): o is Partial<Role> {
    return isPartiallyDescribedByJsonSchema(o, RoleSchema);
}   
            
import {RoleRequest, instanceOfRoleRequest, RoleRequestFromJSON} from './models'; 
                
export const RoleRequestSchema: any = {
    type: 'object',
    properties: {
        name: {
            type: 'string',
        },
        notes: {
            type: 'string',
        },
    },
    required: [
        'name',
    ],
};       

export const asRoleRequest = generateConverterToRx<RoleRequest>(RoleRequestSchema, 'RoleRequestSchema', RoleRequestFromJSON, instanceOfRoleRequest, 'toCamelCase');
export const asRoleRequestArray = generateArrayConverter<RoleRequest>(asRoleRequest);

export function isRoleRequest(o?: any): o is RoleRequest {
    return isDescribedByJsonSchema(o, RoleRequestSchema, false, false);
}   
export function isPartialRoleRequest(o?: any): o is Partial<RoleRequest> {
    return isPartiallyDescribedByJsonSchema(o, RoleRequestSchema);
}   
            
import {RoleResponse, instanceOfRoleResponse, RoleResponseFromJSON} from './models'; 
                
export const RoleResponseSchema: any = {
    type: 'object',
    properties: {
        role: {
            type: 'object',
            properties: {
                parentRoles: {
                    type: 'array',
                    items: {
                        type: 'object',
                        properties: {
                            name: {
                                type: 'string',
                            },
                            id: {
                                type: 'integer',
                                format: 'int64',
                            },
                            enabled: {
                                type: 'boolean',
                            },
                        },
                        required: [
                            'name',
                        ],
                    },
                },
                configItems: {
                    type: 'array',
                    items: {
                        type: 'object',
                        properties: {
                            id: {
                                type: 'integer',
                                format: 'int64',
                            },
                            notes: {
                                type: 'string',
                            },
                            value: {
                                type: 'string',
                            },
                            levelLocked: {
                                type: 'boolean',
                            },
                            allowUserOverride: {
                                type: 'boolean',
                            },
                            relatedProductName: {
                                type: 'string',
                                maxLength: 240,
                            },
                            roleId: {
                                type: 'integer',
                                format: 'int64',
                            },
                            productId: {
                                type: 'integer',
                                format: 'int64',
                            },
                            propertyId: {
                                type: 'integer',
                                format: 'int64',
                            },
                        },
                    },
                },
                id: {
                    type: 'integer',
                    format: 'int64',
                },
                name: {
                    type: 'string',
                },
                notes: {
                    type: 'string',
                },
            },
            required: [
                'parentRoles',
                'id',
                'name',
            ],
        },
        status: {
            type: 'string',
            enum: [
                'SUCCESS',
                'ERROR',
            ],
        },
        statusDescription: {
            type: 'string',
        },
    },
    required: [
        'role',
        'status',
    ],
    discriminator: {
        propertyName: 'openApiType',
    },
};       

export const asRoleResponse = generateConverterToRx<RoleResponse>(RoleResponseSchema, 'RoleResponseSchema', RoleResponseFromJSON, instanceOfRoleResponse, 'toCamelCase');
export const asRoleResponseArray = generateArrayConverter<RoleResponse>(asRoleResponse);

export function isRoleResponse(o?: any): o is RoleResponse {
    return isDescribedByJsonSchema(o, RoleResponseSchema, false, false);
}   
export function isPartialRoleResponse(o?: any): o is Partial<RoleResponse> {
    return isPartiallyDescribedByJsonSchema(o, RoleResponseSchema);
}   
            
import {SearchRoleRequest, instanceOfSearchRoleRequest, SearchRoleRequestFromJSON} from './models'; 
                
export const SearchRoleRequestSchema: any = {
    type: 'object',
    properties: {
        pattern: {
            type: 'string',
        },
        filter: {
            type: 'array',
            items: {
                type: 'integer',
            },
        },
        page: {
            type: 'integer',
            format: 'int32',
            minimum: 0,
            default: 0,
            description: 'Zero-based page index.',
        },
        pageSize: {
            type: 'integer',
            format: 'int32',
            minimum: 1,
            default: 10,
            description: 'Requested records per page. The server caps this value at 100.',
        },
        sortBy: {
            type: 'string',
            description: 'Name of the field to sort by. Allowed values depend on the endpoint and unsupported values fall back to the default ordering.',
        },
        sortOrder: {
            type: 'string',
            enum: [
                'ASC',
                'DESC',
            ],
            default: 'ASC',
            description: 'Sort direction applied to the requested sort field.',
        },
    },
    required: [
        'pattern',
        'page',
        'pageSize',
    ],
};       

export const asSearchRoleRequest = generateConverterToRx<SearchRoleRequest>(SearchRoleRequestSchema, 'SearchRoleRequestSchema', SearchRoleRequestFromJSON, instanceOfSearchRoleRequest, 'toCamelCase');
export const asSearchRoleRequestArray = generateArrayConverter<SearchRoleRequest>(asSearchRoleRequest);

export function isSearchRoleRequest(o?: any): o is SearchRoleRequest {
    return isDescribedByJsonSchema(o, SearchRoleRequestSchema, false, false);
}   
export function isPartialSearchRoleRequest(o?: any): o is Partial<SearchRoleRequest> {
    return isPartiallyDescribedByJsonSchema(o, SearchRoleRequestSchema);
}   
            
import {SearchRoleResponse, instanceOfSearchRoleResponse, SearchRoleResponseFromJSON} from './models'; 
                
export const SearchRoleResponseSchema: any = {
    type: 'object',
    properties: {
        roles: {
            type: 'array',
            description: 'Records for the requested page.',
            items: {
                type: 'object',
                properties: {
                    id: {
                        type: 'integer',
                        format: 'int64',
                    },
                    name: {
                        type: 'string',
                    },
                    notes: {
                        type: 'string',
                    },
                },
            },
        },
        page: {
            type: 'integer',
            format: 'int32',
            minimum: 0,
        },
        pageSize: {
            type: 'integer',
            format: 'int32',
            minimum: 1,
        },
        totalRecords: {
            type: 'integer',
            format: 'int64',
            minimum: 0,
        },
        status: {
            type: 'string',
            enum: [
                'SUCCESS',
                'ERROR',
            ],
        },
        statusDescription: {
            type: 'string',
        },
    },
    required: [
        'roles',
        'page',
        'pageSize',
        'totalRecords',
        'status',
    ],
    discriminator: {
        propertyName: 'openApiType',
    },
};       

export const asSearchRoleResponse = generateConverterToRx<SearchRoleResponse>(SearchRoleResponseSchema, 'SearchRoleResponseSchema', SearchRoleResponseFromJSON, instanceOfSearchRoleResponse, 'toCamelCase');
export const asSearchRoleResponseArray = generateArrayConverter<SearchRoleResponse>(asSearchRoleResponse);

export function isSearchRoleResponse(o?: any): o is SearchRoleResponse {
    return isDescribedByJsonSchema(o, SearchRoleResponseSchema, false, false);
}   
export function isPartialSearchRoleResponse(o?: any): o is Partial<SearchRoleResponse> {
    return isPartiallyDescribedByJsonSchema(o, SearchRoleResponseSchema);
}   
            
import {UpdateRoleRequest, instanceOfUpdateRoleRequest, UpdateRoleRequestFromJSON} from './models'; 
                
export const UpdateRoleRequestSchema: any = {
    type: 'object',
    properties: {
        parentRoles: {
            type: 'array',
            items: {
                type: 'object',
                properties: {
                    id: {
                        type: 'integer',
                        format: 'int64',
                    },
                    enabled: {
                        type: 'boolean',
                    },
                },
            },
        },
        configItems: {
            type: 'array',
            items: {
                type: 'object',
                properties: {
                    id: {
                        type: 'integer',
                        format: 'int64',
                    },
                    notes: {
                        type: 'string',
                    },
                    value: {
                        type: 'string',
                    },
                    levelLocked: {
                        type: 'boolean',
                    },
                    allowUserOverride: {
                        type: 'boolean',
                    },
                    relatedProductName: {
                        type: 'string',
                        maxLength: 240,
                    },
                    roleId: {
                        type: 'integer',
                        format: 'int64',
                    },
                    productId: {
                        type: 'integer',
                        format: 'int64',
                    },
                    propertyId: {
                        type: 'integer',
                        format: 'int64',
                    },
                },
            },
        },
        id: {
            type: 'integer',
            format: 'int64',
        },
        name: {
            type: 'string',
        },
        notes: {
            type: 'string',
        },
    },
    required: [
        'parentRoles',
    ],
};       

export const asUpdateRoleRequest = generateConverterToRx<UpdateRoleRequest>(UpdateRoleRequestSchema, 'UpdateRoleRequestSchema', UpdateRoleRequestFromJSON, instanceOfUpdateRoleRequest, 'toCamelCase');
export const asUpdateRoleRequestArray = generateArrayConverter<UpdateRoleRequest>(asUpdateRoleRequest);

export function isUpdateRoleRequest(o?: any): o is UpdateRoleRequest {
    return isDescribedByJsonSchema(o, UpdateRoleRequestSchema, false, false);
}   
export function isPartialUpdateRoleRequest(o?: any): o is Partial<UpdateRoleRequest> {
    return isPartiallyDescribedByJsonSchema(o, UpdateRoleRequestSchema);
}   
            
import {Status, instanceOfStatus, StatusFromJSON} from './models'; 
                
export const StatusSchema: any = {
    type: 'object',
    discriminator: {
        propertyName: 'openApiType',
    },
    required: [
        'status',
    ],
    properties: {
        status: {
            type: 'string',
            enum: [
                'SUCCESS',
                'ERROR',
            ],
        },
        statusDescription: {
            type: 'string',
        },
    },
};       

export const asStatus = generateConverterToRx<Status>(StatusSchema, 'StatusSchema', StatusFromJSON, instanceOfStatus, 'toCamelCase');
export const asStatusArray = generateArrayConverter<Status>(asStatus);

export function isStatus(o?: any): o is Status {
    return isDescribedByJsonSchema(o, StatusSchema, false, false);
}   
export function isPartialStatus(o?: any): o is Partial<Status> {
    return isPartiallyDescribedByJsonSchema(o, StatusSchema);
}   
            
import {UpdateSite, instanceOfUpdateSite, UpdateSiteFromJSON} from './models'; 
                
export const UpdateSiteSchema: any = {
    type: 'object',
    properties: {
        url: {
            type: 'string',
        },
        id: {
            type: 'integer',
            format: 'int64',
        },
        name: {
            type: 'string',
        },
        notes: {
            type: 'string',
        },
    },
    required: [],
};       

export const asUpdateSite = generateConverterToRx<UpdateSite>(UpdateSiteSchema, 'UpdateSiteSchema', UpdateSiteFromJSON, instanceOfUpdateSite, 'toCamelCase');
export const asUpdateSiteArray = generateArrayConverter<UpdateSite>(asUpdateSite);

export function isUpdateSite(o?: any): o is UpdateSite {
    return isDescribedByJsonSchema(o, UpdateSiteSchema, false, false);
}   
export function isPartialUpdateSite(o?: any): o is Partial<UpdateSite> {
    return isPartiallyDescribedByJsonSchema(o, UpdateSiteSchema);
}   
            
import {UpdateSiteResponse, instanceOfUpdateSiteResponse, UpdateSiteResponseFromJSON} from './models'; 
                
export const UpdateSiteResponseSchema: any = {
    type: 'object',
    properties: {
        updatesite: {
            type: 'object',
            properties: {
                url: {
                    type: 'string',
                },
                id: {
                    type: 'integer',
                    format: 'int64',
                },
                name: {
                    type: 'string',
                },
                notes: {
                    type: 'string',
                },
            },
            required: [],
        },
        status: {
            type: 'string',
            enum: [
                'SUCCESS',
                'ERROR',
            ],
        },
        statusDescription: {
            type: 'string',
        },
    },
    discriminator: {
        propertyName: 'openApiType',
    },
    required: [
        'status',
    ],
};       

export const asUpdateSiteResponse = generateConverterToRx<UpdateSiteResponse>(UpdateSiteResponseSchema, 'UpdateSiteResponseSchema', UpdateSiteResponseFromJSON, instanceOfUpdateSiteResponse, 'toCamelCase');
export const asUpdateSiteResponseArray = generateArrayConverter<UpdateSiteResponse>(asUpdateSiteResponse);

export function isUpdateSiteResponse(o?: any): o is UpdateSiteResponse {
    return isDescribedByJsonSchema(o, UpdateSiteResponseSchema, false, false);
}   
export function isPartialUpdateSiteResponse(o?: any): o is Partial<UpdateSiteResponse> {
    return isPartiallyDescribedByJsonSchema(o, UpdateSiteResponseSchema);
}   
            
import {UpdateSitesSearchRequest, instanceOfUpdateSitesSearchRequest, UpdateSitesSearchRequestFromJSON} from './models'; 
                
export const UpdateSitesSearchRequestSchema: any = {
    type: 'object',
    properties: {
        pattern: {
            type: 'string',
        },
    },
    required: [
        'pattern',
    ],
};       

export const asUpdateSitesSearchRequest = generateConverterToRx<UpdateSitesSearchRequest>(UpdateSitesSearchRequestSchema, 'UpdateSitesSearchRequestSchema', UpdateSitesSearchRequestFromJSON, instanceOfUpdateSitesSearchRequest, 'toCamelCase');
export const asUpdateSitesSearchRequestArray = generateArrayConverter<UpdateSitesSearchRequest>(asUpdateSitesSearchRequest);

export function isUpdateSitesSearchRequest(o?: any): o is UpdateSitesSearchRequest {
    return isDescribedByJsonSchema(o, UpdateSitesSearchRequestSchema, false, false);
}   
export function isPartialUpdateSitesSearchRequest(o?: any): o is Partial<UpdateSitesSearchRequest> {
    return isPartiallyDescribedByJsonSchema(o, UpdateSitesSearchRequestSchema);
}   
            
import {Version, instanceOfVersion, VersionFromJSON} from './models'; 
                
export const VersionSchema: any = {
    type: 'object',
    required: [
        'timestamp',
        'branch',
        'checksum',
        'version',
    ],
    properties: {
        timestamp: {
            type: 'string',
        },
        branch: {
            type: 'string',
        },
        checksum: {
            type: 'string',
        },
        version: {
            type: 'string',
        },
    },
};       

export const asVersion = generateConverterToRx<Version>(VersionSchema, 'VersionSchema', VersionFromJSON, instanceOfVersion, 'toCamelCase');
export const asVersionArray = generateArrayConverter<Version>(asVersion);

export function isVersion(o?: any): o is Version {
    return isDescribedByJsonSchema(o, VersionSchema, false, false);
}   
export function isPartialVersion(o?: any): o is Partial<Version> {
    return isPartiallyDescribedByJsonSchema(o, VersionSchema);
}   
            
